module.exports = { mazdaData: [
  {
    key: '2023750',
    is_active: true,
    title: '2022 Mazda MX-5 Miata Grand Touring',
    year: '2022',
    make: 'Mazda',
    model: 'MX-5 Miata',
    bodyStyle: 'Coupe',
    trim: 'Grand Touring',
    transmission: '',
    drivetrain: 'RWD',
    subTitle: '(Soft Top Only)',
    url: '/searchnew.aspx?year=2022&model=Mazda+MX-5+Miata&trim=Grand+Touring',
    image: 'https://res.cloudinary.com/cfmp/image/upload/f_auto/v1674679551/vehicles/cgi/hyundai/2022/mx-5/2022-mx5-grand-touring-soul-red.png',
    lifestyleImage: '',
    features: [],
    special: [
      // {
      //   type: 'No Payments For 90 Days',
      //   lease: 'false',
      //   pmt: '',
      //   downPmt: '',
      //   term: '',
      //   miles: '',
      //   disclaimer: 'No payments for 90 days for well qualified buyers. May require financing through participating lender. Certain restrictions may apply; Must take new retail delivery from dealer stock by 3/31/2023. See dealer for complete details.',
      // },
      // {
      //   type: 'Lease',
      //   lease: 'true',
      //   pmt: '458',
      //   downPmt: '15% Of MSRP',
      //   term: '36',
      //   miles: '10',
      //   disclaimer: 'Includes any MFS lease cash available and any lease bonus cash available. Excludes $650 acquisition fee, dealer fee $899, FL electronic filing $199.87, FL tag. Requires a 15% of MSRP down payment. Lease offers are 36 months. 10k miles/year. Not to be combined with any other offer. Expires 3/31/2023.',
      // },
      // {
      //   type: 'Lease',
      //   lease: 'true',
      //   pmt: '284',
      //   downPmt: '10% Of MSRP',
      //   term: '36',
      //   miles: '10',
      //   disclaimer: 'Includes any MFS lease cash available and any lease bonus cash available. Excludes $650 acquisition fee, dealer fee $899, FL electronic filing $199.87, FL tag. Requires 10% of MSRP as down payment. Lease offers are 36 months. 10k miles/year. Not to be combined with any other offer. Expires 3/31/2023.',
      // },
      {
        type: 'Finance',
        lease: 'false',
        pmt: '0%',
        downPmt: '',
        term: '36',
        miles: '',
        disclaimer: 'Excludes RF models. Well qualified buyers when financed through participating lender; not all buyers will qualify. Amount of down payment and other factors may affect qualification. Expires 3/31/2023.',
      },
      {
        type: 'Mazda Trade-In Reward Program',
        lease: 'false',
        pmt: '$500',
        downPmt: '',
        term: '',
        miles: '',
        disclaimer: "Mazda Trade-In Reward provides $500 for current Mazda customers who purchase a new 2022 or 2023 Mazda vehicle. Current 2018 or newer Mazda vehicles trade-in is required to participate in the program. The Prior Trade vehicle must have had a Lease Maturity Date on or after July 1st, 2022. The reward may be combined with public offers, customer cash back, and APR incentives/offers. Mazda Trade-In Reward is stackable with Mazda Owner Loyalty, Mazda Lease to Lease Loyalty, Military Program, College Grad, Step-Up, and any other Non-Conquest Private offers. Mazda Trade-In Reward is not stackable with any other private offers, including but not limited to any Conquest Program. Transferable within household (must live at the same address). Proof of eligibility and residency required. See dealer for complete details. Expires: 3/31/2023.",
      },
      {
        type: 'Mazda Loyalty Reward Program',
        lease: 'false',
        pmt: '$500',
        downPmt: '',
        term: '',
        miles: '',
        disclaimer: 'Mazda Loyalty Reward provides $500 for current Mazda customers who purchase or lease a new and unused 2022 or 2023 Mazda vehicle. The reward may be combined with public offers, including lease offers, customer cash back, and APR incentives/offers. Transferable within household (must live at the same address). Proof of eligibility and residency required. Must present dealer with current registration title, current Mazda sales contract or Mazda Financial Services Agreement and valid driver’s license. See dealer for details. Expires: 3/31/2023.',
      },
      {
        type: 'Mazda Conquest Bonus Cash',
        lease: 'false',
        pmt: '$750',
        downPmt: '',
        term: '',
        miles: '',
        disclaimer: '$750 Mazda Conquest Bonus Cash is available on the purchase or lease of any new 2022 Mazda CX-9 to current owners of any 2010 or newer Honda, Toyota, Subaru, Hyundai, KIA, Volkswagen, Ford, Chevrolet, Nissan, Acura, Infiniti and Lexus vehicles. Restrictions apply. Must provide current vehicle registration or proof of auto insurance. No cash value. Trade-in not required. Program is not eligible to stack with Mazda Owner Loyalty incentive. Expires 3/31/2023.',
      },
      {
        type: 'Up To',
        lease: 'false',
        pmt: '$2,250 Off MSRP',
        downPmt: '',
        term: '',
        miles: 'Off',
        disclaimer: 'Excludes RF models. Certain restrictions may apply; Discount does not apply to all models. Must take new retail delivery from dealer stock by 3/31/2023.',
      }
    ],
  },
  {
    key: '2023302',
    is_active: true,
    title: '2023 Mazda CX-30 2.5 S  AWD',
    year: '2023',
    make: 'Mazda',
    model: 'CX-30',
    bodyStyle: 'SUV',
    trim: '2.5 S',
    transmission: 'AT',
    drivetrain: 'AWD',
    subTitle: '',
    url: '/searchnew.aspx?year=2023&model=Mazda+CX-30&trim=2.5+S',
    image: 'https://res.cloudinary.com/cfmp/image/upload/f_auto/v1675910304/vehicles/cgi/mazda/2023/cx-30/2022-cx30-2-5s-jet-black.png',
    lifestyleImage: '',
    features: [],
    special: [
      // {
      //   type: 'No Payments For 90 Days',
      //   lease: 'false',
      //   pmt: '',
      //   downPmt: '',
      //   term: '',
      //   miles: '',
      //   disclaimer: 'No payments for 90 days for well qualified buyers. May require financing through participating lender. Certain restrictions may apply; Must take new retail delivery from dealer stock by 3/31/2023. See dealer for complete details.',
      // },
      {
        type: 'Lease',
        lease: 'true',
        pmt: '199',
        downPmt: '$5,995',
        term: '24',
        miles: '10',
        disclaimer: 'Includes any MFS lease cash available and any lease bonus cash available. Excludes $650 acquisition fee, dealer fee $899, FL electronic filing $199.87, FL tag. Requires $5,995 down payment with approved credit. Lease offers are 36 months. 10k miles/year. Not to be combined with any other offer. Expires 3/31/2023.',
      },
      // {
      //   type: 'True Sign & Drive',
      //   lease: 'true',
      //   pmt: '419',
      //   downPmt: '$0 Down',
      //   term: '36',
      //   miles: '10',
      //   disclaimer: '$0 cash down, $0 security deposit, $0 due at signing. Sign &amp; Drive lease offer for 36 months, 10k miles/year. Not to be combined with any other offer. Expires 3/31/2023.',
      // },
      // {
      //   type: 'Lease',
      //   lease: 'true',
      //   pmt: '377',
      //   downPmt: '$2,999',
      //   term: '36',
      //   miles: '10',
      //   disclaimer: 'Includes any MFS lease cash available and any lease bonus cash available. Excludes $650 acquisition fee, dealer fee $899, FL electronic filing $199.87, FL tag. Requires a $2,999 down payment. Lease offers are 36 months. 10k miles/year. Not to be combined with any other offer. Expires 3/31/2023.',
      // },
      {
        type: 'Finance',
        lease: 'false',
        pmt: '0%',
        downPmt: '',
        term: '36',
        miles: '',
        disclaimer: 'Well qualified buyers when financed through participating lender; not all buyers will qualify. Amount of down payment and other factors may affect qualification. Expires 3/31/2023.',
      },
      {
        type: 'Mazda Loyalty Reward Program',
        lease: 'false',
        pmt: '$500',
        downPmt: '',
        term: '',
        miles: '',
        disclaimer: 'Mazda Loyalty Reward provides $500 for current Mazda customers who purchase or lease a new and unused 2022 or 2023 Mazda vehicle. The reward may be combined with public offers, including lease offers, customer cash back, and APR incentives/offers. Customers may combine Mazda Loyalty Reward with Mazda Military Appreciation Bonus Cash. Additional private incentives must specify combination with Mazda Loyalty Reward. Transferable within household (must live at the same address). Proof of eligibility and residency required. Must present dealer with current registration title, current Mazda sales contract or Mazda Financial Services Agreement and valid driver’s license. Certain restrictions may apply; Must take new retail delivery from dealer stock by 3/31/2023.',
      }
    ],
  },
  {
    key: '2023302',
    is_active: true,
    title: '2023 Mazda CX-30 2.5 S Select AWD',
    year: '2023',
    make: 'Mazda',
    model: 'CX-30',
    bodyStyle: 'SUV',
    trim: '2.5 S Select',
    transmission: 'AT',
    drivetrain: 'AWD',
    subTitle: '',
    url: '/searchnew.aspx?year=2023&model=Mazda+CX-30&trim=2.5+S+Select+AWD',
    image: 'https://res.cloudinary.com/cfmp/image/upload/f_auto/v1672952541/vehicles/cgi/mazda/2023/cx-30/2022-cx30-2-5s-select-platinum-quartz.png',
    lifestyleImage: '',
    features: [],
    special: [
      // {
      //   type: 'No Payments For 90 Days',
      //   lease: 'false',
      //   pmt: '',
      //   downPmt: '',
      //   term: '',
      //   miles: '',
      //   disclaimer: 'No payments for 90 days for well qualified buyers. May require financing through participating lender. Certain restrictions may apply; Must take new retail delivery from dealer stock by 3/31/2023. See dealer for complete details.',
      // },
      {
        type: 'Lease',
        lease: 'true',
        pmt: '245',
        downPmt: '15% Of MSRP',
        term: '36',
        miles: '10',
        disclaimer: 'Includes any MFS lease cash available and any lease bonus cash available. Excludes $650 acquisition fee, dealer fee $899, FL electronic filing $199.87, FL tag. Requires 15% of MSRP down payment with approved credit. Lease offers are 36 months. 10k miles/year. Not to be combined with any other offer. Expires 3/31/2023.',
      },
      {
        type: 'True Sign & Drive',
        lease: 'true',
        pmt: '419',
        downPmt: '$0 Down',
        term: '36',
        miles: '10',
        disclaimer: '$0 cash down, $0 security deposit, $0 due at signing. Sign &amp; Drive lease offer for 36 months, 10k miles/year. Not to be combined with any other offer. Expires 3/31/2023.',
      },
      // {
      //   type: 'Lease',
      //   lease: 'true',
      //   pmt: '377',
      //   downPmt: '$2,999',
      //   term: '36',
      //   miles: '10',
      //   disclaimer: 'Includes any MFS lease cash available and any lease bonus cash available. Excludes $650 acquisition fee, dealer fee $899, FL electronic filing $199.87, FL tag. Requires a $2,999 down payment. Lease offers are 36 months. 10k miles/year. Not to be combined with any other offer. Expires 3/31/2023.',
      // },
      {
        type: 'Finance',
        lease: 'false',
        pmt: '0%',
        downPmt: '',
        term: '36',
        miles: '',
        disclaimer: 'Well qualified buyers when financed through participating lender; not all buyers will qualify. Amount of down payment and other factors may affect qualification. Expires 3/31/2023.',
      },
      {
        type: 'Mazda Loyalty Reward Program',
        lease: 'false',
        pmt: '$500',
        downPmt: '',
        term: '',
        miles: '',
        disclaimer: 'Mazda Loyalty Reward provides $500 for current Mazda customers who purchase or lease a new and unused 2022 or 2023 Mazda vehicle. The reward may be combined with public offers, including lease offers, customer cash back, and APR incentives/offers. Customers may combine Mazda Loyalty Reward with Mazda Military Appreciation Bonus Cash. Additional private incentives must specify combination with Mazda Loyalty Reward. Transferable within household (must live at the same address). Proof of eligibility and residency required. Must present dealer with current registration title, current Mazda sales contract or Mazda Financial Services Agreement and valid driver’s license. Certain restrictions may apply; Must take new retail delivery from dealer stock by 3/31/2023.',
      }
    ],
  },
  {
    key: '239991',
    is_active: true,
    title: '2023 Mazda CX-9 Touring AWD',
    year: '2023',
    make: 'Mazda',
    model: 'CX-9',
    bodyStyle: 'SUV',
    trim: 'Touring',
    transmission: 'AT',
    drivetrain: 'AWD',
    subTitle: '',
    url: '/searchnew.aspx?year=2023&model=Mazda+CX-9&trim=Touring+AWD',
    image: 'https://res.cloudinary.com/cfmp/image/upload/f_auto/v1665504598/vehicles/cgi/mazda/2023/cx-9/2023-cx-9-touring-sonic-silver.png',
    lifestyleImage: '',
    features: [],
    special: [
      // {
      //   type: 'No Payments For 90 Days',
      //   lease: 'false',
      //   pmt: '',
      //   downPmt: '',
      //   term: '',
      //   miles: '',
      //   disclaimer: 'No payments for 90 days for well qualified buyers. May require financing through participating lender. Certain restrictions may apply; Must take new retail delivery from dealer stock by 3/31/2023. See dealer for complete details.',
      // },
      {
        type: 'True Sign & Drive',
        lease: 'true',
        pmt: '499',
        downPmt: '$0 Down',
        term: '36',
        miles: '10',
        disclaimer: '$0 cash down, $0 security deposit, $0 due at signing. Sign &amp; Drive lease offer for 36 months, 10k miles/year. Not to be combined with any other offer. Expires 3/31/2023.',
      },
      // {
      //   type: 'Lease',
      //   lease: 'true',
      //   pmt: '369',
      //   downPmt: '10% Of MSRP',
      //   term: '36',
      //   miles: '10',
      //   disclaimer: 'Includes any MFS lease cash available and any lease bonus cash available. Excludes $650 acquisition fee, dealer fee $899, FL electronic filing $199.87, FL tag. Requires a 15% of MSRP down payment. Lease offers are 36 months. 10k miles/year. Not to be combined with any other offer. Expires 3/31/2023.',
      // },
      // {
      //   type: 'Lease',
      //   lease: 'true',
      //   pmt: '419',
      //   downPmt: '$3,499',
      //   term: '30',
      //   miles: '10',
      //   disclaimer: 'Includes any MFS lease cash available and any lease bonus cash available. Excludes $650 acquisition fee, dealer fee $899, FL electronic filing $199.87, FL tag. Requires a $3,499 down payment. Lease offer is 30 months. 10k miles/year. Not to be combined with any other offer. Expires 3/31/2023.',
      // },
      {
        type: 'Finance',
        lease: 'false',
        pmt: '0%',
        downPmt: '',
        term: '36',
        miles: '',
        disclaimer: 'Well qualified buyers when financed through participating lender; not all buyers will qualify. Amount of down payment and other factors may affect qualification. Expires 3/31/2023.',
      },
      {
        type: 'Mazda Trade-In Reward Program',
        lease: 'false',
        pmt: '$500',
        downPmt: '',
        term: '',
        miles: '',
        disclaimer: "Mazda Trade-In Reward provides $500 for current Mazda customers who purchase a new 2022 or 2023 Mazda vehicle. Current 2018 or newer Mazda vehicles trade-in is required to participate in the program. The Prior Trade vehicle must have had a Lease Maturity Date on or after July 1st, 2022. The reward may be combined with public offers, customer cash back, and APR incentives/offers. Mazda Trade-In Reward is stackable with Mazda Owner Loyalty, Mazda Lease to Lease Loyalty, Military Program, College Grad, Step-Up, and any other Non-Conquest Private offers. Mazda Trade-In Reward is not stackable with any other private offers, including but not limited to any Conquest Program. Transferable within household (must live at the same address). Proof of eligibility and residency required. See dealer for complete details. Expires: 3/31/2023.",
      },
      {
        type: 'Mazda Loyalty Reward Program',
        lease: 'false',
        pmt: '$500',
        downPmt: '',
        term: '',
        miles: '',
        disclaimer: 'Mazda Loyalty Reward provides $500 for current Mazda customers who purchase or lease a new 2022 or 2023 Mazda vehicle. The reward may be combined with public offers, including lease offers, customer cash back, and APR incentives/offers. Transferable within household (must live at the same address). Proof of eligibility and residency required. Must present dealer with current registration title, current Mazda sales contract or Mazda Financial Services Agreement and valid driver’s license. See dealer details. Expires: 3/31/2023.',
      },
      {
        type: 'Mazda Conquest Bonus Cash',
        lease: 'false',
        pmt: '$750',
        downPmt: '',
        term: '',
        miles: '',
        disclaimer: '$750 Mazda Conquest Bonus Cash is available on the purchase or lease of any new 2022 Mazda CX-9 to current owners of any 2010 or newer Honda, Toyota, Subaru, Hyundai, KIA, Volkswagen, Ford, Chevrolet, Nissan, Acura, Infiniti and Lexus vehicles. Restrictions apply. Must provide current vehicle registration or proof of auto insurance. No cash value. Trade-in not required. Program is not eligible to stack with Mazda Owner Loyalty incentive. Expires 3/31/2023.',
      }
    ],
  },
  {
    key: '2398992',
    is_active: true,
    title: '2023 Mazda CX-9 Touring Plus AWD',
    year: '2023',
    make: 'Mazda',
    model: 'CX-9',
    bodyStyle: 'SUV',
    trim: 'Touring Plus',
    transmission: 'AT',
    drivetrain: 'AWD',
    subTitle: '',
    url: '/searchnew.aspx?year=2023&model=Mazda+CX-9&trim=Touring+Plus+AWD',
    image: 'https://res.cloudinary.com/cfmp/image/upload/f_auto/v1665504836/vehicles/cgi/mazda/2023/cx-9/2022-cx-9-touring-plus-snowflake-white-pearl.png',
    lifestyleImage: '',
    features: [],
    special: [
      // {
      //   type: 'No Payments For 90 Days',
      //   lease: 'false',
      //   pmt: '',
      //   downPmt: '',
      //   term: '',
      //   miles: '',
      //   disclaimer: 'No payments for 90 days for well qualified buyers. May require financing through participating lender. Certain restrictions may apply; Must take new retail delivery from dealer stock by 3/31/2023. See dealer for complete details.',
      // },
      {
        type: 'True Sign & Drive',
        lease: 'true',
        pmt: '525',
        downPmt: '$0 Down',
        term: '36',
        miles: '10',
        disclaimer: '$0 cash down, $0 security deposit, $0 due at signing. Sign &amp; Drive lease offer for 36 months, 10k miles/year. Not to be combined with any other offer. Expires 3/31/2023.',
      },
      // {
      //   type: 'Lease',
      //   lease: 'true',
      //   pmt: '396',
      //   downPmt: '10% Of MSRP',
      //   term: '36',
      //   miles: '10',
      //   disclaimer: 'Includes any MFS lease cash available and any lease bonus cash available. Excludes $650 acquisition fee, dealer fee $899, FL electronic filing $199.87, FL tag. Requires a 15% of MSRP down payment. Lease offers are 36 months. 10k miles/year. Not to be combined with any other offer. Expires 3/31/2023.',
      // },
      // {
      //   type: 'Lease',
      //   lease: 'true',
      //   pmt: '369',
      //   downPmt: '$3,499',
      //   term: '30',
      //   miles: '10',
      //   disclaimer: 'Includes any MFS lease cash available and any lease bonus cash available. Excludes $650 acquisition fee, dealer fee $899, FL electronic filing $199.87, FL tag. Requires a $3,499 down payment. Lease offer is 30 months. 10k miles/year. Not to be combined with any other offer. Expires 3/31/2023.',
      // },
      {
        type: 'Finance',
        lease: 'false',
        pmt: '0%',
        downPmt: '',
        term: '36',
        miles: '',
        disclaimer: 'Well qualified buyers when financed through participating lender; not all buyers will qualify. Amount of down payment and other factors may affect qualification. Expires 3/31/2023.',
      },
      {
        type: 'Mazda Trade-In Reward Program',
        lease: 'false',
        pmt: '$500',
        downPmt: '',
        term: '',
        miles: '',
        disclaimer: "Mazda Trade-In Reward provides $500 for current Mazda customers who purchase a new 2022 or 2023 Mazda vehicle. Current 2018 or newer Mazda vehicles trade-in is required to participate in the program. The Prior Trade vehicle must have had a Lease Maturity Date on or after July 1st, 2022. The reward may be combined with public offers, customer cash back, and APR incentives/offers. Mazda Trade-In Reward is stackable with Mazda Owner Loyalty, Mazda Lease to Lease Loyalty, Military Program, College Grad, Step-Up, and any other Non-Conquest Private offers. Mazda Trade-In Reward is not stackable with any other private offers, including but not limited to any Conquest Program. Transferable within household (must live at the same address). Proof of eligibility and residency required. See dealer for complete details. Expires: 3/31/2023.",
      },
      {
        type: 'Mazda Loyalty Reward Program',
        lease: 'false',
        pmt: '$500',
        downPmt: '',
        term: '',
        miles: '',
        disclaimer: 'Mazda Loyalty Reward provides $500 for current Mazda customers who purchase or lease a new and unused 2022 or 2023 Mazda vehicle. The reward may be combined with public offers, including lease offers, customer cash back, and APR incentives/offers. Transferable within household (must live at the same address). Proof of eligibility and residency required. Must present dealer with current registration title, current Mazda sales contract or Mazda Financial Services Agreement and valid driver’s license. See dealer for details. Expires: 3/31/2023.',
      },
      {
        type: 'Mazda Conquest Bonus Cash',
        lease: 'false',
        pmt: '$750',
        downPmt: '',
        term: '',
        miles: '',
        disclaimer: '$750 Mazda Conquest Bonus Cash is available on the purchase or lease of any new 2022 Mazda CX-9 to current owners of any 2010 or newer Honda, Toyota, Subaru, Hyundai, KIA, Volkswagen, Ford, Chevrolet, Nissan, Acura, Infiniti and Lexus vehicles. Restrictions apply. Must provide current vehicle registration or proof of auto insurance. No cash value. Trade-in not required. Program is not eligible to stack with Mazda Owner Loyalty incentive. Expires 3/31/2023.',
      }
    ],
  },
  {
    key: '2398993',
    is_active: true,
    title: '2023 Mazda CX-9 Carbon Edition AWD',
    year: '2023',
    make: 'Mazda',
    model: 'CX-9',
    bodyStyle: 'SUV',
    trim: 'Carbon Edition',
    transmission: 'AT',
    drivetrain: 'AWD',
    subTitle: '',
    url: '/searchnew.aspx?year=2023&model=Mazda+CX-9&trim=Carbon+Edition+AWD',
    image: 'https://res.cloudinary.com/cfmp/image/upload/f_auto/v1671812107/vehicles/cgi/mazda/2023/cx-9/2023-cx-9-carbon-edition-polymetal-gray.png',
    lifestyleImage: '',
    features: [],
    special: [
      // {
      //   type: 'No Payments For 90 Days',
      //   lease: 'false',
      //   pmt: '',
      //   downPmt: '',
      //   term: '',
      //   miles: '',
      //   disclaimer: 'No payments for 90 days for well qualified buyers. May require financing through participating lender. Certain restrictions may apply; Must take new retail delivery from dealer stock by 3/31/2023. See dealer for complete details.',
      // },
      {
        type: 'True Sign & Drive',
        lease: 'true',
        pmt: '569',
        downPmt: '$0 Down',
        term: '36',
        miles: '10',
        disclaimer: '$0 cash down, $0 security deposit, $0 due at signing. Sign &amp; Drive lease offer for 36 months, 10k miles/year. Not to be combined with any other offer. Expires 3/31/2023.',
      },
      // {
      //   type: 'Lease',
      //   lease: 'true',
      //   pmt: '396',
      //   downPmt: '10% Of MSRP',
      //   term: '36',
      //   miles: '10',
      //   disclaimer: 'Includes any MFS lease cash available and any lease bonus cash available. Excludes $650 acquisition fee, dealer fee $899, FL electronic filing $199.87, FL tag. Requires a 15% of MSRP down payment. Lease offers are 36 months. 10k miles/year. Not to be combined with any other offer. Expires 3/31/2023.',
      // },
      // {
      //   type: 'Lease',
      //   lease: 'true',
      //   pmt: '369',
      //   downPmt: '$3,499',
      //   term: '30',
      //   miles: '10',
      //   disclaimer: 'Includes any MFS lease cash available and any lease bonus cash available. Excludes $650 acquisition fee, dealer fee $899, FL electronic filing $199.87, FL tag. Requires a $3,499 down payment. Lease offer is 30 months. 10k miles/year. Not to be combined with any other offer. Expires 3/31/2023.',
      // },
      {
        type: 'Finance',
        lease: 'false',
        pmt: '0%',
        downPmt: '',
        term: '36',
        miles: '',
        disclaimer: 'Well qualified buyers when financed through participating lender; not all buyers will qualify. Amount of down payment and other factors may affect qualification. Expires 3/31/2023.',
      },
      {
        type: 'Mazda Trade-In Reward Program',
        lease: 'false',
        pmt: '$500',
        downPmt: '',
        term: '',
        miles: '',
        disclaimer: "Mazda Trade-In Reward provides $500 for current Mazda customers who purchase a new 2022 or 2023 Mazda vehicle. Current 2018 or newer Mazda vehicles trade-in is required to participate in the program. The Prior Trade vehicle must have had a Lease Maturity Date on or after July 1st, 2022. The reward may be combined with public offers, customer cash back, and APR incentives/offers. Mazda Trade-In Reward is stackable with Mazda Owner Loyalty, Mazda Lease to Lease Loyalty, Military Program, College Grad, Step-Up, and any other Non-Conquest Private offers. Mazda Trade-In Reward is not stackable with any other private offers, including but not limited to any Conquest Program. Transferable within household (must live at the same address). Proof of eligibility and residency required. See dealer for complete details. Expires: 3/31/2023.",
      },
      {
        type: 'Mazda Loyalty Reward Program',
        lease: 'false',
        pmt: '$500',
        downPmt: '',
        term: '',
        miles: '',
        disclaimer: 'Mazda Loyalty Reward provides $500 for current Mazda customers who purchase or lease a new and unused 2022 or 2023 Mazda vehicle. The reward may be combined with public offers, including lease offers, customer cash back, and APR incentives/offers. Transferable within household (must live at the same address). Proof of eligibility and residency required. Must present dealer with current registration title, current Mazda sales contract or Mazda Financial Services Agreement and valid driver’s license. See dealer for details. Expires: 3/31/2023.',
      },
      {
        type: 'Mazda Conquest Bonus Cash',
        lease: 'false',
        pmt: '$750',
        downPmt: '',
        term: '',
        miles: '',
        disclaimer: '$750 Mazda Conquest Bonus Cash is available on the purchase or lease of any new 2022 Mazda CX-9 to current owners of any 2010 or newer Honda, Toyota, Subaru, Hyundai, KIA, Volkswagen, Ford, Chevrolet, Nissan, Acura, Infiniti and Lexus vehicles. Restrictions apply. Must provide current vehicle registration or proof of auto insurance. No cash value. Trade-in not required. Program is not eligible to stack with Mazda Owner Loyalty incentive. Expires 3/31/2023.',
      }
    ],
  },
  {
    key: '2399994',
    is_active: true,
    title: '2023 Mazda CX-9 Grand Touring AWD',
    year: '2023',
    make: 'Mazda',
    model: 'CX-9',
    bodyStyle: 'SUV',
    trim: 'Grand Touring',
    transmission: 'AT',
    drivetrain: 'AWD',
    subTitle: '',
    url: '/searchnew.aspx?year=2023&model=Mazda+CX-9&trim=Grand+Touring+AWD',
    image: 'https://res.cloudinary.com/cfmp/image/upload/f_auto/v1667417836/vehicles/cgi/mazda/2023/cx-9/2022-cx-9-grand-touring-soul-red-crystal.png',
    lifestyleImage: '',
    features: [],
    special: [
      // {
      //   type: 'No Payments For 90 Days',
      //   lease: 'false',
      //   pmt: '',
      //   downPmt: '',
      //   term: '',
      //   miles: '',
      //   disclaimer: 'No payments for 90 days for well qualified buyers. May require financing through participating lender. Certain restrictions may apply; Must take new retail delivery from dealer stock by 3/31/2023. See dealer for complete details.',
      // },
      {
        type: 'True Sign & Drive',
        lease: 'true',
        pmt: '589',
        downPmt: '$0 Down',
        term: '36',
        miles: '10',
        disclaimer: '$0 cash down, $0 security deposit, $0 due at signing. Sign &amp; Drive lease offer for 36 months, 10k miles/year. Not to be combined with any other offer. Expires 3/31/2023.',
      },
      // {
      //   type: 'Lease',
      //   lease: 'true',
      //   pmt: '407',
      //   downPmt: '10% Of MSRP',
      //   term: '36',
      //   miles: '10',
      //   disclaimer: 'Includes any MFS lease cash available and any lease bonus cash available. Excludes $650 acquisition fee, dealer fee $899, FL electronic filing $199.87, FL tag. Requires a 15% of MSRP down payment. Lease offers are 36 months. 10k miles/year. Not to be combined with any other offer. Expires 3/31/2023.',
      // },
      // {
      //   type: 'Lease',
      //   lease: 'true',
      //   pmt: '469',
      //   downPmt: '$3,999',
      //   term: '30',
      //   miles: '10',
      //   disclaimer: 'Includes any MFS lease cash available and any lease bonus cash available. Excludes $650 acquisition fee, dealer fee $899, FL electronic filing $199.87, FL tag. Requires a $3,999 down payment. Lease offer is 30 months. 10k miles/year. Not to be combined with any other offer. Expires 3/31/2023.',
      // },
      {
        type: 'Finance',
        lease: 'false',
        pmt: '0%',
        downPmt: '',
        term: '36',
        miles: '',
        disclaimer: 'Well qualified buyers when financed through participating lender; not all buyers will qualify. Amount of down payment and other factors may affect qualification. Expires 3/31/2023.',
      },
      {
        type: 'Mazda Trade-In Reward Program',
        lease: 'false',
        pmt: '$500',
        downPmt: '',
        term: '',
        miles: '',
        disclaimer: "Mazda Trade-In Reward provides $500 for current Mazda customers who purchase a new 2022 or 2023 Mazda vehicle. Current 2018 or newer Mazda vehicles trade-in is required to participate in the program. The Prior Trade vehicle must have had a Lease Maturity Date on or after July 1st, 2022. The reward may be combined with public offers, customer cash back, and APR incentives/offers. Mazda Trade-In Reward is stackable with Mazda Owner Loyalty, Mazda Lease to Lease Loyalty, Military Program, College Grad, Step-Up, and any other Non-Conquest Private offers. Mazda Trade-In Reward is not stackable with any other private offers, including but not limited to any Conquest Program. Transferable within household (must live at the same address). Proof of eligibility and residency required. See dealer for complete details. Expires: 3/31/2023.",
      },
      {
        type: 'Mazda Loyalty Reward Program',
        lease: 'false',
        pmt: '$500',
        downPmt: '',
        term: '',
        miles: '',
        disclaimer: 'Mazda Loyalty Reward provides $500 for current Mazda customers who purchase or lease a new and unused 2022 or 2023 Mazda vehicle. The reward may be combined with public offers, including lease offers, customer cash back, and APR incentives/offers. Transferable within household (must live at the same address). Proof of eligibility and residency required. Must present dealer with current registration title, current Mazda sales contract or Mazda Financial Services Agreement and valid driver’s license. See dealer for details. Expires: 3/31/2023.',
      },
      {
        type: 'Mazda Conquest Bonus Cash',
        lease: 'false',
        pmt: '$750',
        downPmt: '',
        term: '',
        miles: '',
        disclaimer: '$750 Mazda Conquest Bonus Cash is available on the purchase or lease of any new 2022 Mazda CX-9 to current owners of any 2010 or newer Honda, Toyota, Subaru, Hyundai, KIA, Volkswagen, Ford, Chevrolet, Nissan, Acura, Infiniti and Lexus vehicles. Restrictions apply. Must provide current vehicle registration or proof of auto insurance. No cash value. Trade-in not required. Program is not eligible to stack with Mazda Owner Loyalty incentive. Expires 3/31/2023.',
      }
    ],
  },
  {
    key: '2399995',
    is_active: true,
    title: '2023 Mazda CX-9 Signature AWD',
    year: '2023',
    make: 'Mazda',
    model: 'CX-9',
    bodyStyle: 'SUV',
    trim: 'Signature',
    transmission: 'AT',
    drivetrain: 'AWD',
    subTitle: '',
    url: '/searchnew.aspx?year=2023&model=Mazda+CX-9&trim=Signature+AWD',
    image: 'https://res.cloudinary.com/cfmp/image/upload/f_auto/v1671812379/vehicles/cgi/mazda/2023/cx-9/2022-cx9-signature-machine-gray.png',
    lifestyleImage: '',
    features: [],
    special: [
      // {
      //   type: 'No Payments For 90 Days',
      //   lease: 'false',
      //   pmt: '',
      //   downPmt: '',
      //   term: '',
      //   miles: '',
      //   disclaimer: 'No payments for 90 days for well qualified buyers. May require financing through participating lender. Certain restrictions may apply; Must take new retail delivery from dealer stock by 3/31/2023. See dealer for complete details.',
      // },
      {
        type: 'True Sign & Drive',
        lease: 'true',
        pmt: '619',
        downPmt: '$0 Down',
        term: '36',
        miles: '10',
        disclaimer: '$0 cash down, $0 security deposit, $0 due at signing. Sign &amp; Drive lease offer for 36 months, 10k miles/year. Not to be combined with any other offer. Expires 3/31/2023.',
      },
      // {
      //   type: 'Lease',
      //   lease: 'true',
      //   pmt: '407',
      //   downPmt: '10% Of MSRP',
      //   term: '36',
      //   miles: '10',
      //   disclaimer: 'Includes any MFS lease cash available and any lease bonus cash available. Excludes $650 acquisition fee, dealer fee $899, FL electronic filing $199.87, FL tag. Requires a 15% of MSRP down payment. Lease offers are 36 months. 10k miles/year. Not to be combined with any other offer. Expires 3/31/2023.',
      // },
      // {
      //   type: 'Lease',
      //   lease: 'true',
      //   pmt: '469',
      //   downPmt: '$3,999',
      //   term: '30',
      //   miles: '10',
      //   disclaimer: 'Includes any MFS lease cash available and any lease bonus cash available. Excludes $650 acquisition fee, dealer fee $899, FL electronic filing $199.87, FL tag. Requires a $3,999 down payment. Lease offer is 30 months. 10k miles/year. Not to be combined with any other offer. Expires 3/31/2023.',
      // },
      {
        type: 'Finance',
        lease: 'false',
        pmt: '0%',
        downPmt: '',
        term: '36',
        miles: '',
        disclaimer: 'Well qualified buyers when financed through participating lender; not all buyers will qualify. Amount of down payment and other factors may affect qualification. Expires 3/31/2023.',
      },
      {
        type: 'Mazda Trade-In Reward Program',
        lease: 'false',
        pmt: '$500',
        downPmt: '',
        term: '',
        miles: '',
        disclaimer: "Mazda Trade-In Reward provides $500 for current Mazda customers who purchase a new 2022 or 2023 Mazda vehicle. Current 2018 or newer Mazda vehicles trade-in is required to participate in the program. The Prior Trade vehicle must have had a Lease Maturity Date on or after July 1st, 2022. The reward may be combined with public offers, customer cash back, and APR incentives/offers. Mazda Trade-In Reward is stackable with Mazda Owner Loyalty, Mazda Lease to Lease Loyalty, Military Program, College Grad, Step-Up, and any other Non-Conquest Private offers. Mazda Trade-In Reward is not stackable with any other private offers, including but not limited to any Conquest Program. Transferable within household (must live at the same address). Proof of eligibility and residency required. See dealer for complete details. Expires: 3/31/2023.",
      },
      {
        type: 'Mazda Loyalty Reward Program',
        lease: 'false',
        pmt: '$500',
        downPmt: '',
        term: '',
        miles: '',
        disclaimer: 'Mazda Loyalty Reward provides $500 for current Mazda customers who purchase or lease a new and unused 2022 or 2023 Mazda vehicle. The reward may be combined with public offers, including lease offers, customer cash back, and APR incentives/offers. Transferable within household (must live at the same address). Proof of eligibility and residency required. Must present dealer with current registration title, current Mazda sales contract or Mazda Financial Services Agreement and valid driver’s license. See dealer for details. Expires: 3/31/2023.',
      },
      {
        type: 'Mazda Conquest Bonus Cash',
        lease: 'false',
        pmt: '$750',
        downPmt: '',
        term: '',
        miles: '',
        disclaimer: '$750 Mazda Conquest Bonus Cash is available on the purchase or lease of any new 2022 Mazda CX-9 to current owners of any 2010 or newer Honda, Toyota, Subaru, Hyundai, KIA, Volkswagen, Ford, Chevrolet, Nissan, Acura, Infiniti and Lexus vehicles. Restrictions apply. Must provide current vehicle registration or proof of auto insurance. No cash value. Trade-in not required. Program is not eligible to stack with Mazda Owner Loyalty incentive. Expires 3/31/2023.',
      }
    ],
  },
  {
    key: '101',
    is_active: true,
    title: '2023 Mazda CX-5 2.5 S AT AWD',
    year: '2023',
    make: 'Mazda',
    model: 'CX-5',
    bodyStyle: 'SUV',
    trim: '2.5 S',
    transmission: 'AT',
    drivetrain: 'AWD',
    subTitle: '',
    url: '/searchnew.aspx?year=2023&model=Mazda+CX-5&trim=2.5+S,2.5+S+AWD',
    image: 'https://res.cloudinary.com/cfmp/image/upload/f_auto/v1665175890/vehicles/cgi/mazda/2023/cx-5/2022-cx5-2.5-s-jet-black-mica-carousel.png',
    lifestyleImage: '',
    features: [],
    special: [
      // {
      //   type: 'No Payments For 90 Days',
      //   lease: 'false',
      //   pmt: '',
      //   downPmt: '',
      //   term: '',
      //   miles: '',
      //   disclaimer: 'No payments for 90 days for well qualified buyers. May require financing through participating lender. Certain restrictions may apply; Must take new retail delivery from dealer stock by 3/31/2023. See dealer for complete details.',
      // },
      {
        type: 'Lease',
        lease: 'true',
        pmt: '249',
        downPmt: '15% Of MSRP',
        term: '36',
        miles: '10',
        disclaimer: 'Includes any MFS lease cash available and any lease bonus cash available. Excludes $650 acquisition fee, dealer fee $899, FL electronic filing $199.87, FL tag. Requires a 15% of MSRP down payment. Lease offers are 36 months. 10k miles/year. Not to be combined with any other offer. Expires 3/31/2023.',
      },
      {
        type: 'True Sign & Drive',
        lease: 'true',
        pmt: '435',
        downPmt: '$0 Down',
        term: '36',
        miles: '10',
        disclaimer: '$0 cash down, $0 security deposit, $0 due at signing. Sign &amp; Drive lease offer for 36 months, 10k miles/year. Not to be combined with any other offer. Expires 3/31/2023.',
      },
      // {
      //   type: 'Lease',
      //   lease: 'true',
      //   pmt: '259',
      //   downPmt: '10% Of MSRP',
      //   term: '36',
      //   miles: '10',
      //   disclaimer: 'Includes any MFS lease cash available and any lease bonus cash available. Excludes $650 acquisition fee, dealer fee $899, FL electronic filing $199.87, FL tag. Requires 10% of MSRP as down payment. Lease offers are 36 months. 10k miles/year. Not to be combined with any other offer. Expires 3/31/2023.',
      // },
      {
        type: 'Finance',
        lease: 'false',
        pmt: '0%',
        downPmt: '',
        term: '36',
        miles: '',
        disclaimer: 'Well qualified buyers when financed through participating lender; not all buyers will qualify. Amount of down payment and other factors may affect qualification. Expires 3/31/2023.',
      },
      {
        type: 'Mazda Loyalty Reward Program',
        lease: 'false',
        pmt: '$500',
        downPmt: '',
        term: '',
        miles: '',
        disclaimer: 'Mazda Loyalty Reward provides $500 for current Mazda customers who purchase or lease a new and unused 2022 or 2023 Mazda vehicle. The reward may be combined with public offers, including lease offers, customer cash back, and APR incentives/offers. Customers may combine Mazda Loyalty Reward with Mazda Military Appreciation Bonus Cash. Additional private incentives must specify combination with Mazda Loyalty Reward. Transferable within household (must live at the same address). Proof of eligibility and residency required. Must present dealer with current registration title, current Mazda sales contract or Mazda Financial Services Agreement and valid driver’s license. Certain restrictions may apply; Must take new retail delivery from dealer stock by 3/31/2023.',
      }
    ],
  },
  {
    key: '202352',
    is_active: true,
    title: '2023 Mazda CX-5 2.5 S Select AT AWD',
    year: '2023',
    make: 'Mazda',
    model: 'CX-5',
    bodyStyle: 'SUV',
    trim: '2.5 Select',
    transmission: 'AT',
    drivetrain: 'AWD',
    subTitle: '',
    url: '/searchnew.aspx?year=2023&model=Mazda+CX-5&trim=2.5+S+Select+AWD,2.5+S+Select+Package',
    image: 'https://res.cloudinary.com/cfmp/image/upload/f_auto/v1665503414/vehicles/cgi/mazda/2023/cx-5/2022-cx5-2-5s-select-sonic-silver-metallic.png',
    lifestyleImage: '',
    features: [],
    special: [
      // {
      //   type: 'No Payments For 90 Days',
      //   lease: 'false',
      //   pmt: '',
      //   downPmt: '',
      //   term: '',
      //   miles: '',
      //   disclaimer: 'No payments for 90 days for well qualified buyers. May require financing through participating lender. Certain restrictions may apply; Must take new retail delivery from dealer stock by 3/31/2023. See dealer for complete details.',
      // },
      {
        type: 'Lease',
        lease: 'true',
        pmt: '263',
        downPmt: '15% Of MSRP',
        term: '36',
        miles: '10',
        disclaimer: 'Includes any MFS lease cash available and any lease bonus cash available. Excludes $650 acquisition fee, dealer fee $899, FL electronic filing $199.87, FL tag. Requires a 15% of MSRP down payment. Lease offers are 36 months. 10k miles/year. Not to be combined with any other offer. Expires 3/31/2023.',
      },
      {
        type: 'True Sign & Drive',
        lease: 'true',
        pmt: '469',
        downPmt: '$0 Down',
        term: '36',
        miles: '10',
        disclaimer: '$0 cash down, $0 security deposit, $0 due at signing. Sign &amp; Drive lease offer for 36 months, 10k miles/year. Not to be combined with any other offer. Expires 3/31/2023.',
      },
      // {
      //   type: 'Lease',
      //   lease: 'true',
      //   pmt: '259',
      //   downPmt: '10% Of MSRP',
      //   term: '36',
      //   miles: '10',
      //   disclaimer: 'Includes any MFS lease cash available and any lease bonus cash available. Excludes $650 acquisition fee, dealer fee $899, FL electronic filing $199.87, FL tag. Requires 10% of MSRP as down payment. Lease offers are 36 months. 10k miles/year. Not to be combined with any other offer. Expires 3/31/2023.',
      // },
      {
        type: 'Finance',
        lease: 'false',
        pmt: '0%',
        downPmt: '',
        term: '36',
        miles: '',
        disclaimer: 'Well qualified buyers when financed through participating lender; not all buyers will qualify. Amount of down payment and other factors may affect qualification. Expires 3/31/2023.',
      },
      {
        type: 'Mazda Loyalty Reward Program',
        lease: 'false',
        pmt: '$500',
        downPmt: '',
        term: '',
        miles: '',
        disclaimer: 'Mazda Loyalty Reward provides $500 for current Mazda customers who purchase or lease a new and unused 2022 or 2023 Mazda vehicle. The reward may be combined with public offers, including lease offers, customer cash back, and APR incentives/offers. Customers may combine Mazda Loyalty Reward with Mazda Military Appreciation Bonus Cash. Additional private incentives must specify combination with Mazda Loyalty Reward. Transferable within household (must live at the same address). Proof of eligibility and residency required. Must present dealer with current registration title, current Mazda sales contract or Mazda Financial Services Agreement and valid driver’s license. Certain restrictions may apply; Must take new retail delivery from dealer stock by 3/31/2023.',
      },
    ],
  },
  {
    key: '202353',
    is_active: true,
    title: '2023 Mazda CX-5 2.5 S Preferred AT AWD',
    year: '2023',
    make: 'Mazda',
    model: 'CX-5',
    bodyStyle: 'SUV',
    trim: '2.5 Preferred',
    transmission: 'AT',
    drivetrain: 'AWD',
    subTitle: '',
    url: '/searchnew.aspx?year=2023&model=Mazda+CX-5&trim=2.5+S+Preferred+Package,2.5+Preferred+AWD',
    image: 'https://res.cloudinary.com/cfmp/image/upload/f_auto/v1670445256/vehicles/cgi/mazda/2023/cx-5/2022-cx5-2.5-s-preferred-eternal-blue-mica-carousel.png',
    lifestyleImage: '',
    features: [],
    special: [
      // {
      //   type: 'No Payments For 90 Days',
      //   lease: 'false',
      //   pmt: '',
      //   downPmt: '',
      //   term: '',
      //   miles: '',
      //   disclaimer: 'No payments for 90 days for well qualified buyers. May require financing through participating lender. Certain restrictions may apply; Must take new retail delivery from dealer stock by 3/31/2023. See dealer for complete details.',
      // },
      {
        type: 'Lease',
        lease: 'true',
        pmt: '270',
        downPmt: '15% Of MSRP',
        term: '36',
        miles: '10',
        disclaimer: 'Includes any MFS lease cash available and any lease bonus cash available. Excludes $650 acquisition fee, dealer fee $899, FL electronic filing $199.87, FL tag. Requires a 15% of MSRP down payment. Lease offers are 36 months. 10k miles/year. Not to be combined with any other offer. Expires 3/31/2023.',
      },
      {
        type: 'True Sign & Drive',
        lease: 'true',
        pmt: '485',
        downPmt: '$0 Down',
        term: '36',
        miles: '10',
        disclaimer: '$0 cash down, $0 security deposit, $0 due at signing. Sign &amp; Drive lease offer for 36 months, 10k miles/year. Not to be combined with any other offer. Expires 3/31/2023.',
      },
      // {
      //   type: 'Lease',
      //   lease: 'true',
      //   pmt: '259',
      //   downPmt: '10% Of MSRP',
      //   term: '36',
      //   miles: '10',
      //   disclaimer: 'Includes any MFS lease cash available and any lease bonus cash available. Excludes $650 acquisition fee, dealer fee $899, FL electronic filing $199.87, FL tag. Requires 10% of MSRP as down payment. Lease offers are 36 months. 10k miles/year. Not to be combined with any other offer. Expires 3/31/2023.',
      // },
      {
        type: 'Finance',
        lease: 'false',
        pmt: '0%',
        downPmt: '',
        term: '36',
        miles: '',
        disclaimer: 'Well qualified buyers when financed through participating lender; not all buyers will qualify. Amount of down payment and other factors may affect qualification. Expires 3/31/2023.',
      },
      {
        type: 'Mazda Loyalty Reward Program',
        lease: 'false',
        pmt: '$500',
        downPmt: '',
        term: '',
        miles: '',
        disclaimer: 'Mazda Loyalty Reward provides $500 for current Mazda customers who purchase or lease a new and unused 2022 or 2023 Mazda vehicle. The reward may be combined with public offers, including lease offers, customer cash back, and APR incentives/offers. Customers may combine Mazda Loyalty Reward with Mazda Military Appreciation Bonus Cash. Additional private incentives must specify combination with Mazda Loyalty Reward. Transferable within household (must live at the same address). Proof of eligibility and residency required. Must present dealer with current registration title, current Mazda sales contract or Mazda Financial Services Agreement and valid driver’s license. Certain restrictions may apply; Must take new retail delivery from dealer stock by 3/31/2023.',
      }
    ],
  },
  {
    key: '202354',
    is_active: true,
    title: '2023 Mazda CX-5 2.5 S Carbon Edition AT AWD',
    year: '2023',
    make: 'Mazda',
    model: 'CX-5',
    bodyStyle: 'SUV',
    trim: '2.5 Carbon Edition',
    transmission: 'AT',
    drivetrain: 'AWD',
    subTitle: '',
    url: '/searchnew.aspx?year=2023&model=Mazda+CX-5&trim=2.5+Carbon+Edition+AWD',
    image: 'https://res.cloudinary.com/cfmp/image/upload/f_auto/v1670445256/vehicles/cgi/mazda/2023/cx-5/2022-cx5-2-5s-polymetal-gray-carbon-edition.png',
    lifestyleImage: '',
    features: [],
    special: [
      // {
      //   type: 'No Payments For 90 Days',
      //   lease: 'false',
      //   pmt: '',
      //   downPmt: '',
      //   term: '',
      //   miles: '',
      //   disclaimer: 'No payments for 90 days for well qualified buyers. May require financing through participating lender. Certain restrictions may apply; Must take new retail delivery from dealer stock by 3/31/2023. See dealer for complete details.',
      // },
      {
        type: 'Lease',
        lease: 'true',
        pmt: '280',
        downPmt: '15% Of MSRP',
        term: '36',
        miles: '10',
        disclaimer: 'Includes any MFS lease cash available and any lease bonus cash available. Excludes $650 acquisition fee, dealer fee $899, FL electronic filing $199.87, FL tag. Requires a 15% of MSRP down payment. Lease offers are 36 months. 10k miles/year. Not to be combined with any other offer. Expires 3/31/2023.',
      },
      {
        type: 'True Sign & Drive',
        lease: 'true',
        pmt: '495',
        downPmt: '$0 Down',
        term: '36',
        miles: '10',
        disclaimer: '$0 cash down, $0 security deposit, $0 due at signing. Sign &amp; Drive lease offer for 36 months, 10k miles/year. Not to be combined with any other offer. Expires 3/31/2023.',
      },
      // {
      //   type: 'Lease',
      //   lease: 'true',
      //   pmt: '259',
      //   downPmt: '10% Of MSRP',
      //   term: '36',
      //   miles: '10',
      //   disclaimer: 'Includes any MFS lease cash available and any lease bonus cash available. Excludes $650 acquisition fee, dealer fee $899, FL electronic filing $199.87, FL tag. Requires 10% of MSRP as down payment. Lease offers are 36 months. 10k miles/year. Not to be combined with any other offer. Expires 3/31/2023.',
      // },
      {
        type: 'Finance',
        lease: 'false',
        pmt: '0%',
        downPmt: '',
        term: '36',
        miles: '',
        disclaimer: 'Well qualified buyers when financed through participating lender; not all buyers will qualify. Amount of down payment and other factors may affect qualification. Expires 3/31/2023.',
      },
      {
        type: 'Mazda Loyalty Reward Program',
        lease: 'false',
        pmt: '$500',
        downPmt: '',
        term: '',
        miles: '',
        disclaimer: 'Mazda Loyalty Reward provides $500 for current Mazda customers who purchase or lease a new and unused 2022 or 2023 Mazda vehicle. The reward may be combined with public offers, including lease offers, customer cash back, and APR incentives/offers. Customers may combine Mazda Loyalty Reward with Mazda Military Appreciation Bonus Cash. Additional private incentives must specify combination with Mazda Loyalty Reward. Transferable within household (must live at the same address). Proof of eligibility and residency required. Must present dealer with current registration title, current Mazda sales contract or Mazda Financial Services Agreement and valid driver’s license. Certain restrictions may apply; Must take new retail delivery from dealer stock by 3/31/2023.',
      }
    ],
  },
  {
    key: '202355',
    is_active: true,
    title: '2023 Mazda CX-5 2.5 S Premium AT AWD',
    year: '2023',
    make: 'Mazda',
    model: 'CX-5',
    bodyStyle: 'SUV',
    trim: '2.5 Premium',
    transmission: 'AT',
    drivetrain: 'AWD',
    subTitle: '',
    url: '/searchnew.aspx?year=2023&model=Mazda+CX-5&trim=2.5+Premium+AWD,2.5+S+Premium+Package',
    image: 'https://res.cloudinary.com/cfmp/image/upload/f_auto/v1670445256/vehicles/cgi/mazda/2023/cx-5/2022-cx5-2-5s-premium-soul-red-crystal-metallic.png',
    lifestyleImage: '',
    features: [],
    special: [
      // {
      //   type: 'No Payments For 90 Days',
      //   lease: 'false',
      //   pmt: '',
      //   downPmt: '',
      //   term: '',
      //   miles: '',
      //   disclaimer: 'No payments for 90 days for well qualified buyers. May require financing through participating lender. Certain restrictions may apply; Must take new retail delivery from dealer stock by 3/31/2023. See dealer for complete details.',
      // },
      {
        type: 'Lease',
        lease: 'true',
        pmt: '290',
        downPmt: '15% Of MSRP',
        term: '36',
        miles: '10',
        disclaimer: 'Includes any MFS lease cash available and any lease bonus cash available. Excludes $650 acquisition fee, dealer fee $899, FL electronic filing $199.87, FL tag. Requires a 15% of MSRP down payment. Lease offers are 36 months. 10k miles/year. Not to be combined with any other offer. Expires 3/31/2023.',
      },
      {
        type: 'True Sign & Drive',
        lease: 'true',
        pmt: '495',
        downPmt: '$0 Down',
        term: '36',
        miles: '10',
        disclaimer: '$0 cash down, $0 security deposit, $0 due at signing. Sign &amp; Drive lease offer for 36 months, 10k miles/year. Not to be combined with any other offer. Expires 3/31/2023.',
      },
      // {
      //   type: 'Lease',
      //   lease: 'true',
      //   pmt: '259',
      //   downPmt: '10% Of MSRP',
      //   term: '36',
      //   miles: '10',
      //   disclaimer: 'Includes any MFS lease cash available and any lease bonus cash available. Excludes $650 acquisition fee, dealer fee $899, FL electronic filing $199.87, FL tag. Requires 10% of MSRP as down payment. Lease offers are 36 months. 10k miles/year. Not to be combined with any other offer. Expires 3/31/2023.',
      // },
      {
        type: 'Finance',
        lease: 'false',
        pmt: '0%',
        downPmt: '',
        term: '36',
        miles: '',
        disclaimer: 'Well qualified buyers when financed through participating lender; not all buyers will qualify. Amount of down payment and other factors may affect qualification. Expires 3/31/2023.',
      },
      {
        type: 'Mazda Loyalty Reward Program',
        lease: 'false',
        pmt: '$500',
        downPmt: '',
        term: '',
        miles: '',
        disclaimer: 'Mazda Loyalty Reward provides $500 for current Mazda customers who purchase or lease a new and unused 2022 or 2023 Mazda vehicle. The reward may be combined with public offers, including lease offers, customer cash back, and APR incentives/offers. Customers may combine Mazda Loyalty Reward with Mazda Military Appreciation Bonus Cash. Additional private incentives must specify combination with Mazda Loyalty Reward. Transferable within household (must live at the same address). Proof of eligibility and residency required. Must present dealer with current registration title, current Mazda sales contract or Mazda Financial Services Agreement and valid driver’s license. Certain restrictions may apply; Must take new retail delivery from dealer stock by 3/31/2023.',
      }
    ],
  },
  {
    key: '202356',
    is_active: true,
    title: '2023 Mazda CX-5 2.5 S Premium Plus AT AWD',
    year: '2023',
    make: 'Mazda',
    model: 'CX-5',
    bodyStyle: 'SUV',
    trim: '2.5 Premium Plus',
    transmission: 'AT',
    drivetrain: 'AWD',
    subTitle: '',
    url: '/searchnew.aspx?year=2023&model=Mazda+CX-5&trim=2.5+S+Premium+Plus,2.5+Premium+Plus+AWD',
    image: 'https://res.cloudinary.com/cfmp/image/upload/f_auto/v1665503411/vehicles/cgi/mazda/2023/cx-5/2022-cx5-2-5s-premium-plus-machine-gray-metallic.png',
    lifestyleImage: '',
    features: [],
    special: [
      // {
      //   type: 'No Payments For 90 Days',
      //   lease: 'false',
      //   pmt: '',
      //   downPmt: '',
      //   term: '',
      //   miles: '',
      //   disclaimer: 'No payments for 90 days for well qualified buyers. May require financing through participating lender. Certain restrictions may apply; Must take new retail delivery from dealer stock by 3/31/2023. See dealer for complete details.',
      // },
      {
        type: 'Lease',
        lease: 'true',
        pmt: '298',
        downPmt: '15% Of MSRP',
        term: '36',
        miles: '10',
        disclaimer: 'Includes any MFS lease cash available and any lease bonus cash available. Excludes $650 acquisition fee, dealer fee $899, FL electronic filing $199.87, FL tag. Requires a 15% of MSRP down payment. Lease offers are 36 months. 10k miles/year. Not to be combined with any other offer. Expires 3/31/2023.',
      },
      {
        type: 'True Sign & Drive',
        lease: 'true',
        pmt: '529',
        downPmt: '$0 Down',
        term: '36',
        miles: '10',
        disclaimer: '$0 cash down, $0 security deposit, $0 due at signing. Sign &amp; Drive lease offer for 36 months, 10k miles/year. Not to be combined with any other offer. Expires 3/31/2023.',
      },
      // {
      //   type: 'Lease',
      //   lease: 'true',
      //   pmt: '259',
      //   downPmt: '10% Of MSRP',
      //   term: '36',
      //   miles: '10',
      //   disclaimer: 'Includes any MFS lease cash available and any lease bonus cash available. Excludes $650 acquisition fee, dealer fee $899, FL electronic filing $199.87, FL tag. Requires 10% of MSRP as down payment. Lease offers are 36 months. 10k miles/year. Not to be combined with any other offer. Expires 3/31/2023.',
      // },
      {
        type: 'Finance',
        lease: 'false',
        pmt: '0%',
        downPmt: '',
        term: '36',
        miles: '',
        disclaimer: 'Well qualified buyers when financed through participating lender; not all buyers will qualify. Amount of down payment and other factors may affect qualification. Expires 3/31/2023.',
      },
      {
        type: 'Mazda Loyalty Reward Program',
        lease: 'false',
        pmt: '$500',
        downPmt: '',
        term: '',
        miles: '',
        disclaimer: 'Mazda Loyalty Reward provides $500 for current Mazda customers who purchase or lease a new and unused 2022 or 2023 Mazda vehicle. The reward may be combined with public offers, including lease offers, customer cash back, and APR incentives/offers. Customers may combine Mazda Loyalty Reward with Mazda Military Appreciation Bonus Cash. Additional private incentives must specify combination with Mazda Loyalty Reward. Transferable within household (must live at the same address). Proof of eligibility and residency required. Must present dealer with current registration title, current Mazda sales contract or Mazda Financial Services Agreement and valid driver’s license. Certain restrictions may apply; Must take new retail delivery from dealer stock by 3/31/2023.',
      }
    ],
  },
  {
    key: '202357',
    is_active: true,
    title: '2023 Mazda CX-5 2.5 Turbo AT AWD',
    year: '2023',
    make: 'Mazda',
    model: 'CX-5',
    bodyStyle: 'SUV',
    trim: '2.5 Turbo',
    transmission: 'AT',
    drivetrain: 'AWD',
    subTitle: '',
    url: '/searchnew.aspx?year=2023&model=Mazda+CX-5&trim=2.5+Turbo+AWD',
    image: 'https://res.cloudinary.com/cfmp/image/upload/f_auto/v1670445256/vehicles/cgi/mazda/2023/cx-5/2022-cx5-2-5-turbo-soul-red-crystal-metallic.png',
    lifestyleImage: '',
    features: [],
    special: [
      // {
      //   type: 'No Payments For 90 Days',
      //   lease: 'false',
      //   pmt: '',
      //   downPmt: '',
      //   term: '',
      //   miles: '',
      //   disclaimer: 'No payments for 90 days for well qualified buyers. May require financing through participating lender. Certain restrictions may apply; Must take new retail delivery from dealer stock by 3/31/2023. See dealer for complete details.',
      // },
      {
        type: 'Lease',
        lease: 'true',
        pmt: '309',
        downPmt: '15% Of MSRP',
        term: '36',
        miles: '10',
        disclaimer: 'Includes any MFS lease cash available and any lease bonus cash available. Excludes $650 acquisition fee, dealer fee $899, FL electronic filing $199.87, FL tag. Requires a 15% of MSRP down payment. Lease offers are 36 months. 10k miles/year. Not to be combined with any other offer. Expires 3/31/2023.',
      },
      {
        type: 'True Sign & Drive',
        lease: 'true',
        pmt: '545',
        downPmt: '$0 Down',
        term: '36',
        miles: '10',
        disclaimer: '$0 cash down, $0 security deposit, $0 due at signing. Sign &amp; Drive lease offer for 36 months, 10k miles/year. Not to be combined with any other offer. Expires 3/31/2023.',
      },
      // {
      //   type: 'Lease',
      //   lease: 'true',
      //   pmt: '259',
      //   downPmt: '10% Of MSRP',
      //   term: '36',
      //   miles: '10',
      //   disclaimer: 'Includes any MFS lease cash available and any lease bonus cash available. Excludes $650 acquisition fee, dealer fee $899, FL electronic filing $199.87, FL tag. Requires 10% of MSRP as down payment. Lease offers are 36 months. 10k miles/year. Not to be combined with any other offer. Expires 3/31/2023.',
      // },
      {
        type: 'Finance',
        lease: 'false',
        pmt: '0%',
        downPmt: '',
        term: '36',
        miles: '',
        disclaimer: 'Well qualified buyers when financed through participating lender; not all buyers will qualify. Amount of down payment and other factors may affect qualification. Expires 3/31/2023.',
      },
      {
        type: 'Mazda Loyalty Reward Program',
        lease: 'false',
        pmt: '$500',
        downPmt: '',
        term: '',
        miles: '',
        disclaimer: 'Mazda Loyalty Reward provides $500 for current Mazda customers who purchase or lease a new and unused 2022 or 2023 Mazda vehicle. The reward may be combined with public offers, including lease offers, customer cash back, and APR incentives/offers. Customers may combine Mazda Loyalty Reward with Mazda Military Appreciation Bonus Cash. Additional private incentives must specify combination with Mazda Loyalty Reward. Transferable within household (must live at the same address). Proof of eligibility and residency required. Must present dealer with current registration title, current Mazda sales contract or Mazda Financial Services Agreement and valid driver’s license. Certain restrictions may apply; Must take new retail delivery from dealer stock by 3/31/2023.',
      }
    ],
  },
  {
    key: '202358',
    is_active: true,
    title: '2023 Mazda CX-5 2.5 Turbo Signature AT AWD',
    year: '2023',
    make: 'Mazda',
    model: 'CX-5',
    bodyStyle: 'SUV',
    trim: '2.5 Turbo Signature',
    transmission: 'AT',
    drivetrain: 'AWD',
    subTitle: '',
    url: '/searchnew.aspx?year=2023&model=Mazda+CX-5&trim=2.5+Turbo+Signature+AWD',
    image: 'https://res.cloudinary.com/cfmp/image/upload/f_auto/v1665503416/vehicles/cgi/mazda/2023/cx-5/2023-cx5-2-5-turbo-signature-rhodium-white.png',
    lifestyleImage: '',
    features: [],
    special: [
      // {
      //   type: 'No Payments For 90 Days',
      //   lease: 'false',
      //   pmt: '',
      //   downPmt: '',
      //   term: '',
      //   miles: '',
      //   disclaimer: 'No payments for 90 days for well qualified buyers. May require financing through participating lender. Certain restrictions may apply; Must take new retail delivery from dealer stock by 3/31/2023. See dealer for complete details.',
      // },
      {
        type: 'Lease',
        lease: 'true',
        pmt: '334',
        downPmt: '15% Of MSRP',
        term: '36',
        miles: '10',
        disclaimer: 'Includes any MFS lease cash available and any lease bonus cash available. Excludes $650 acquisition fee, dealer fee $899, FL electronic filing $199.87, FL tag. Requires a 15% of MSRP down payment. Lease offers are 36 months. 10k miles/year. Not to be combined with any other offer. Expires 3/31/2023.',
      },
      {
        type: 'True Sign & Drive',
        lease: 'true',
        pmt: '575',
        downPmt: '$0 Down',
        term: '36',
        miles: '10',
        disclaimer: '$0 cash down, $0 security deposit, $0 due at signing. Sign &amp; Drive lease offer for 36 months, 10k miles/year. Not to be combined with any other offer. Expires 3/31/2023.',
      },
      // {
      //   type: 'Lease',
      //   lease: 'true',
      //   pmt: '259',
      //   downPmt: '10% Of MSRP',
      //   term: '36',
      //   miles: '10',
      //   disclaimer: 'Includes any MFS lease cash available and any lease bonus cash available. Excludes $650 acquisition fee, dealer fee $899, FL electronic filing $199.87, FL tag. Requires 10% of MSRP as down payment. Lease offers are 36 months. 10k miles/year. Not to be combined with any other offer. Expires 3/31/2023.',
      // },
      {
        type: 'Finance',
        lease: 'false',
        pmt: '0%',
        downPmt: '',
        term: '36',
        miles: '',
        disclaimer: 'Well qualified buyers when financed through participating lender; not all buyers will qualify. Amount of down payment and other factors may affect qualification. Expires 3/31/2023.',
      },
      {
        type: 'Mazda Loyalty Reward Program',
        lease: 'false',
        pmt: '$500',
        downPmt: '',
        term: '',
        miles: '',
        disclaimer: 'Mazda Loyalty Reward provides $500 for current Mazda customers who purchase or lease a new and unused 2022 or 2023 Mazda vehicle. The reward may be combined with public offers, including lease offers, customer cash back, and APR incentives/offers. Customers may combine Mazda Loyalty Reward with Mazda Military Appreciation Bonus Cash. Additional private incentives must specify combination with Mazda Loyalty Reward. Transferable within household (must live at the same address). Proof of eligibility and residency required. Must present dealer with current registration title, current Mazda sales contract or Mazda Financial Services Agreement and valid driver’s license. Certain restrictions may apply; Must take new retail delivery from dealer stock by 3/31/2023.',
      }
    ],
  },
  {
    key: '701',
    is_active: false,
    title: '2021 Mazda3 Sedan Base',
    year: '2021',
    make: 'Mazda',
    model: 'Mazda3 Sedan',
    bodyStyle: 'Sedan',
    trim: 'Base',
    transmission: 'AT',
    drivetrain: '',
    subTitle: '',
    url: '/searchnew.aspx?year=2021&model=Mazda3',
    image: 'https://res.cloudinary.com/cfmp/image/upload/f_auto/v1604594227/vehicles/cgi/mazda/2021/m3-sedan/2021-mazda-3-sedan-2.0l-package-black.png',
    lifestyleImage: '',
    features: [],
    special: [
      {
        type: 'Lease',
        lease: 'true',
        pmt: '179',
        downPmt: '15% Of MSRP',
        term: '36',
        miles: '10',
        disclaimer: 'Includes any MFS lease cash available and any lease bonus cash available. Excludes $650 acquisition fee, dealer fee $899, FL electronic filing $199.87, FL tag. Requires a 15% of MSRP down payment. Lease offers are 24 months. 10k miles/year. Not to be combined with any other offer. Expires 3/31/2023.',
      },
      {
        type: 'Finance',
        lease: 'false',
        pmt: '2.9%',
        downPmt: '',
        term: '36',
        miles: '',
        disclaimer: 'Well qualified buyers when financed through participating lender; not all buyers will qualify. Amount of down payment and other factors may affect qualification. Expires 3/31/2023.',
      }
    ],
  },
    {
    key: '801',
    is_active: false,
    title: '2021 Mazda6 Sport AT',
    year: '2021',
    make: 'Mazda',
    model: 'Mazda6',
    bodyStyle: 'Sedan',
    trim: 'Sport',
    transmission: 'AT',
    drivetrain: '',
    subTitle: '',
    url: '/searchnew.aspx?year=2021&model=Mazda6&trim=Sport',
    image: 'https://res.cloudinary.com/cfmp/image/upload/f_auto/v1369871266/vehicles/cgi/mazda/2021/m6/2021-mazda6-sport-machine-gray.png',
    lifestyleImage: '',
    features: [],
    special: [
      {
        type: 'Lease',
        lease: 'true',
        pmt: '229',
        downPmt: '15% Of MSRP',
        term: '36',
        miles: '10',
        disclaimer: 'Includes any MFS lease cash available and any lease bonus cash available. Excludes $650 acquisition fee, dealer fee $899, FL electronic filing $199.87, FL tag. Requires a 15% of MSRP down payment. Lease offers are 24 months. 10k miles/year. Not to be combined with any other offer. Expires 3/31/2023.',
      },
      {
        type: 'Finance',
        lease: 'false',
        pmt: '1.9%',
        downPmt: '',
        term: '36',
        miles: '',
        disclaimer: 'Well qualified buyers when financed through participating lender; not all buyers will qualify. Amount of down payment and other factors may affect qualification. Expires 3/31/2023.',
      }
    ],
  },
    {
    key: '901',
    is_active: false,
    title: '2021 Mazda6 Grand Touring AT FWD',
    year: '2021',
    make: 'Mazda',
    model: 'Mazda6',
    bodyStyle: 'Sedan',
    trim: 'Grand Touring',
    transmission: 'AT',
    drivetrain: 'FWD',
    subTitle: '',
    url: '/searchnew.aspx?year=2021&model=Mazda6&trim=Grand+Touring',
    image: 'https://res.cloudinary.com/cfmp/image/upload/f_auto/v1633713341/vehicles/cgi/mazda/2021/m6/m6-gt.png',
    lifestyleImage: '',
    features: [],
    special: [
      {
        type: 'Lease',
        lease: 'true',
        pmt: '275',
        downPmt: '15% Of MSRP',
        term: '36',
        miles: '10',
        disclaimer: 'Includes any MFS lease cash available and any lease bonus cash available. Excludes $650 acquisition fee, dealer fee $899, FL electronic filing $199.87, FL tag. Requires a 15% of MSRP down payment. Lease offers are 36 months. 10k miles/year. Not to be combined with any other offer. Expires 3/31/2023.',
      },
      {
        type: 'Finance',
        lease: 'false',
        pmt: '1.9%',
        downPmt: '',
        term: '36',
        miles: '',
        disclaimer: 'Well qualified buyers when financed through participating lender; not all buyers will qualify. Amount of down payment and other factors may affect qualification. Expires 3/31/2023.',
      }
    ],
  },
    {
    key: '1001',
    is_active: false,
    title: '2021 Mazda6 Carbon Edition AT',
    year: '2021',
    make: 'Mazda',
    model: 'Mazda6',
    bodyStyle: 'Sedan',
    trim: 'Carbon Edition',
    transmission: 'AT',
    drivetrain: '',
    subTitle: '',
    url: '/searchnew.aspx?year=2021&model=Mazda6&trim=Carbon+Edition',
    image: 'https://res.cloudinary.com/cfmp/image/upload/f_auto/v1633713338/vehicles/cgi/mazda/2021/m6/m6-carbon.png',
    lifestyleImage: '',
    features: [],
    special: [
      {
        type: 'Lease',
        lease: 'true',
        pmt: '305',
        downPmt: '15% Of MSRP',
        term: '36',
        miles: '10',
        disclaimer: 'Includes any MFS lease cash available and any lease bonus cash available. Excludes $650 acquisition fee, dealer fee $899, FL electronic filing $199.87, FL tag. Requires a 15% of MSRP down payment. Lease offers are 24 months. 10k miles/year. Not to be combined with any other offer. Expires 3/31/2023.',
      },
      {
        type: 'Finance',
        lease: 'false',
        pmt: '1.9%',
        downPmt: '',
        term: '36',
        miles: '',
        disclaimer: 'Well qualified buyers when financed through participating lender; not all buyers will qualify. Amount of down payment and other factors may affect qualification. Expires 3/31/2023.',
      }
    ],
  },
    {
    key: '202331',
    is_active: true,
    title: '2023 Mazda3 Hatchback 2.5 S Select FWD',
    year: '2023',
    make: 'Mazda',
    model: 'Mazda3 Hatchback',
    bodyStyle: 'Hatchback',
    trim: '2.5 S Select',
    transmission: 'AT',
    drivetrain: 'FWD',
    subTitle: '',
    url: '/searchnew.aspx?year=2023&model=Mazda3+Hatchback',
    image: 'https://res.cloudinary.com/cfmp/image/upload/f_auto/v1670447436/vehicles/cgi/mazda/2023/m3-hatch/2022-m3h-select-platinium-quartz.png',
    lifestyleImage: '',
    features: [],
    special: [
      // {
      //   type: 'No Payments For 90 Days',
      //   lease: 'false',
      //   pmt: '',
      //   downPmt: '',
      //   term: '',
      //   miles: '',
      //   disclaimer: 'No payments for 90 days for well qualified buyers. May require financing through participating lender. Certain restrictions may apply; Must take new retail delivery from dealer stock by 3/31/2023. See dealer for complete details.',
      // },
      {
        type: 'Lease',
        lease: 'true',
        pmt: '259',
        downPmt: '15% Of MSRP',
        term: '36',
        miles: '10',
        disclaimer: 'Includes any MFS lease cash available and any lease bonus cash available. Excludes $650 acquisition fee, dealer fee $899, FL electronic filing $199.87, FL tag. Requires a 15% of MSRP down payment. Lease offers are 36 months. 10k miles/year. Not to be combined with any other offer. Expires 3/31/2023.',
      },
      // {
      //   type: 'Lease',
      //   lease: 'true',
      //   pmt: '229',
      //   downPmt: '$2,999',
      //   term: '36',
      //   miles: '10',
      //   disclaimer: 'Includes any MFS lease cash available and any lease bonus cash available. Excludes $650 acquisition fee, dealer fee $899, FL electronic filing $199.87, FL tag. Requires a $2,999 down payment. Lease offers are 36 months. 10k miles/year. Not to be combined with any other offer. Expires 3/31/2023.',
      // },
      {
        type: 'Finance',
        lease: 'false',
        pmt: '2.9%',
        downPmt: '',
        term: '36',
        miles: '',
        disclaimer: 'Well qualified buyers when financed through participating lender; not all buyers will qualify. Amount of down payment and other factors may affect qualification. Expires 3/31/2023.',
      },
      {
        type: 'Mazda Loyalty Reward Program',
        lease: 'false',
        pmt: '$500',
        downPmt: '',
        term: '',
        miles: '',
        disclaimer: 'Mazda Loyalty Reward provides $500 for current Mazda customers who purchase or lease a new and unused 2022 or 2023 Mazda vehicle. The reward may be combined with public offers, including lease offers, customer cash back, and APR incentives/offers. Transferable within household (must live at the same address). Proof of eligibility and residency required. Must present dealer with current registration title, current Mazda sales contract or Mazda Financial Services Agreement and valid driver’s license. See dealer for details. Expires: 3/31/2023.',
      },
    ],
  },
  {
    key: '1401',
    is_active: false,
    title: '2022 Mazda CX-30 2.5 S',
    year: '2022',
    make: 'Mazda',
    model: 'CX-30',
    bodyStyle: 'SUV',
    trim: '2.5 S',
    transmission: 'AT',
    drivetrain: 'AWD',
    subTitle: '',
    url: '/searchnew.aspx?year=2022&model=Mazda+CX-30&trim=2.5+S',
    image: 'https://res.cloudinary.com/cfmp/image/upload/f_auto/v1644526202/vehicles/cgi/mazda/2022/cx-30/cx30-s.png',
    lifestyleImage: '',
    features: [],
    special: [
      // {
      //   type: 'Lease',
      //   lease: 'true',
      //   pmt: '129',
      //   downPmt: '15% Of MSRP',
      //   term: '24',
      //   miles: '10',
      //   disclaimer: 'Includes any MFS lease cash available and any lease bonus cash available. Excludes $650 acquisition fee, dealer fee $899, FL electronic filing $199.87, FL tag. Requires a 15% of MSRP down payment. Lease offers are 24 months. 10k miles/year. Not to be combined with any other offer. Expires 3/31/2023.',
      // },
      // {
      //   type: 'Lease',
      //   lease: 'true',
      //   pmt: '219',
      //   downPmt: '$2,999',
      //   term: '36',
      //   miles: '10',
      //   disclaimer: 'Includes any MFS lease cash available and any lease bonus cash available. Excludes $650 acquisition fee, dealer fee $899, FL electronic filing $199.87, FL tag. Requires a $2,999 down payment. Lease offers are 36 months. 10k miles/year. Not to be combined with any other offer. Expires 3/31/2023.',
      // },
      {
        type: 'Finance',
        lease: 'false',
        pmt: '1.9%',
        downPmt: '',
        term: '36',
        miles: '',
        disclaimer: 'Well qualified buyers when financed through participating lender; not all buyers will qualify. Amount of down payment and other factors may affect qualification. Expires 3/31/2023.',
      }
    ],
  },
  {
    key: '1411',
    is_active: false,
    title: '2022 Mazda CX-30 2.5 S Select Package',
    year: '2022',
    make: 'Mazda',
    model: 'CX-30',
    bodyStyle: 'SUV',
    trim: '2.5 S Select Package',
    transmission: 'AT',
    drivetrain: 'AWD',
    subTitle: '',
    url: '/searchnew.aspx?year=2022&model=Mazda+CX-30&trim=2.5+S+Select+Package',
    image: 'https://res.cloudinary.com/cfmp/image/upload/f_auto/v1644526202/vehicles/cgi/mazda/2022/cx-30/cx30-select.png',
    lifestyleImage: '',
    features: [],
    special: [
      // {
      //   type: 'Lease',
      //   lease: 'true',
      //   pmt: '145',
      //   downPmt: '15% Of MSRP',
      //   term: '24',
      //   miles: '10',
      //   disclaimer: 'Includes any MFS lease cash available and any lease bonus cash available. Excludes $650 acquisition fee, dealer fee $899, FL electronic filing $199.87, FL tag. Requires a 15% of MSRP down payment. Lease offers are 24 months. 10k miles/year. Not to be combined with any other offer. Expires 3/31/2023.',
      // },
      // {
      //   type: 'Lease',
      //   lease: 'true',
      //   pmt: '256',
      //   downPmt: '$2,999',
      //   term: '36',
      //   miles: '10',
      //   disclaimer: 'Includes any MFS lease cash available and any lease bonus cash available. Excludes $650 acquisition fee, dealer fee $899, FL electronic filing $199.87, FL tag. Requires a $2,999 down payment. Lease offers are 36 months. 10k miles/year. Not to be combined with any other offer. Expires 3/31/2023.',
      // },
      {
        type: 'Finance',
        lease: 'false',
        pmt: '1.9%',
        downPmt: '',
        term: '36',
        miles: '',
        disclaimer: 'Well qualified buyers when financed through participating lender; not all buyers will qualify. Amount of down payment and other factors may affect qualification. Expires 3/31/2023.',
      }
    ],
  },
  {
    key: '1421',
    is_active: false,
    title: '2022 Mazda CX-30 2.5 S Preferred Package',
    year: '2022',
    make: 'Mazda',
    model: 'CX-30',
    bodyStyle: 'SUV',
    trim: '2.5 S Preferred Package',
    transmission: 'AT',
    drivetrain: 'AWD',
    subTitle: '',
    url: '/searchnew.aspx?year=2022&model=Mazda+CX-30&trim=2.5+S+Preferred+Package',
    image: 'https://res.cloudinary.com/cfmp/image/upload/f_auto/v1644526203/vehicles/cgi/mazda/2022/cx-30/cx30-preferred.png',
    lifestyleImage: '',
    features: [],
    special: [
      // {
      //   type: 'Lease',
      //   lease: 'true',
      //   pmt: '185',
      //   downPmt: '15% Of MSRP',
      //   term: '24',
      //   miles: '10',
      //   disclaimer: 'Includes any MFS lease cash available and any lease bonus cash available. Excludes $650 acquisition fee, dealer fee $899, FL electronic filing $199.87, FL tag. Requires a 15% of MSRP down payment. Lease offers are 24 months. 10k miles/year. Not to be combined with any other offer. Expires 3/31/2023.',
      // },
      // {
      //   type: 'Lease',
      //   lease: 'true',
      //   pmt: '287',
      //   downPmt: '$2,999',
      //   term: '36',
      //   miles: '10',
      //   disclaimer: 'Includes any MFS lease cash available and any lease bonus cash available. Excludes $650 acquisition fee, dealer fee $899, FL electronic filing $199.87, FL tag. Requires a $2,999 down payment. Lease offers are 36 months. 10k miles/year. Not to be combined with any other offer. Expires 3/31/2023.',
      // },
      {
        type: 'Finance',
        lease: 'false',
        pmt: '3.9%',
        downPmt: '',
        term: '60',
        miles: '',
        disclaimer: 'Well qualified buyers when financed through participating lender; not all buyers will qualify. Amount of down payment and other factors may affect qualification. Expires 3/31/2023.',
      },
      {
        type: 'Mazda Loyalty Reward Program',
        lease: 'false',
        pmt: '$500',
        downPmt: '',
        term: '',
        miles: '',
        disclaimer: 'Mazda Loyalty Reward provides $500 for current Mazda customers who purchase or lease a new and unused 2022 or 2023 Mazda vehicle. The reward may be combined with public offers, including lease offers, customer cash back, and APR incentives/offers. Customers may combine Mazda Loyalty Reward with Mazda Military Appreciation Bonus Cash. Additional private incentives must specify combination with Mazda Loyalty Reward. Transferable within household (must live at the same address). Proof of eligibility and residency required. Must present dealer with current registration title, current Mazda sales contract or Mazda Financial Services Agreement and valid driver’s license. Certain restrictions may apply; Must take new retail delivery from dealer stock by 3/31/2023.',
      }
    ],
  },
  {
    key: '1431',
    is_active: false,
    title: '2022 Mazda CX-30 2.5 S Carbon Edition',
    year: '2022',
    make: 'Mazda',
    model: 'CX-30',
    bodyStyle: 'SUV',
    trim: '2.5 S Carbon Edition',
    transmission: 'AT',
    drivetrain: 'AWD',
    subTitle: '',
    url: '/searchnew.aspx?year=2022&model=Mazda+CX-30&trim=2.5+S+Carbon+Edition',
    image: 'https://res.cloudinary.com/cfmp/image/upload/f_auto/v1644526203/vehicles/cgi/mazda/2022/cx-30/cx30-carbon.png',
    lifestyleImage: '',
    features: [],
    special: [
      // {
      //   type: 'Lease',
      //   lease: 'true',
      //   pmt: '361',
      //   downPmt: '15% Of MSRP',
      //   term: '36',
      //   miles: '10',
      //   disclaimer: 'Includes any MFS lease cash available and any lease bonus cash available. Excludes $650 acquisition fee, dealer fee $899, FL electronic filing $199.87, FL tag. Requires a 15% of MSRP down payment. Lease offers are 36 months. 10k miles/year. Not to be combined with any other offer. Expires 3/31/2023.',
      // },
      // {
      //   type: 'Lease',
      //   lease: 'true',
      //   pmt: '292',
      //   downPmt: '$2,999',
      //   term: '36',
      //   miles: '10',
      //   disclaimer: 'Includes any MFS lease cash available and any lease bonus cash available. Excludes $650 acquisition fee, dealer fee $899, FL electronic filing $199.87, FL tag. Requires a $2,999 down payment. Lease offers are 36 months. 10k miles/year. Not to be combined with any other offer. Expires 3/31/2023.',
      // },
      {
        type: 'Finance',
        lease: 'false',
        pmt: '3.9%',
        downPmt: '',
        term: '60',
        miles: '',
        disclaimer: 'Well qualified buyers when financed through participating lender; not all buyers will qualify. Amount of down payment and other factors may affect qualification. Expires 3/31/2023.',
      },
      {
        type: 'Mazda Loyalty Reward Program',
        lease: 'false',
        pmt: '$500',
        downPmt: '',
        term: '',
        miles: '',
        disclaimer: 'Mazda Loyalty Reward provides $500 for current Mazda customers who purchase or lease a new and unused 2022 or 2023 Mazda vehicle. The reward may be combined with public offers, including lease offers, customer cash back, and APR incentives/offers. Customers may combine Mazda Loyalty Reward with Mazda Military Appreciation Bonus Cash. Additional private incentives must specify combination with Mazda Loyalty Reward. Transferable within household (must live at the same address). Proof of eligibility and residency required. Must present dealer with current registration title, current Mazda sales contract or Mazda Financial Services Agreement and valid driver’s license. Certain restrictions may apply; Must take new retail delivery from dealer stock by 3/31/2023.',
      }
    ],
  },
  {
    key: '1432',
    is_active: false,
    title: '2022 Mazda CX-30 2.5 S Premium Package',
    year: '2022',
    make: 'Mazda',
    model: 'CX-30',
    bodyStyle: 'SUV',
    trim: '2.5 S Premium Package',
    transmission: 'AT',
    drivetrain: 'AWD',
    subTitle: '',
    url: '/searchnew.aspx?year=2022&model=Mazda+CX-30&trim=2.5+S+Premium+Package',
    image: 'https://res.cloudinary.com/cfmp/image/upload/f_auto/v1644526202/vehicles/cgi/mazda/2022/cx-30/cx30-premium.png',
    lifestyleImage: '',
    features: [],
    special: [
      {
        type: 'Lease',
        lease: 'true',
        pmt: '255',
        downPmt: '15% Of MSRP',
        term: '36',
        miles: '10',
        disclaimer: 'Includes any MFS lease cash available and any lease bonus cash available. Excludes $650 acquisition fee, $899 dealer fee, FL electronic filing $199.87, FL tag. Requires a 15% of MSRP down payment. Lease offers are 36 months. 10k miles/year. Not to be combined with any other offer. Expires 3/31/2023.',
      },
      // {
      //   type: 'Lease',
      //   lease: 'true',
      //   pmt: '301',
      //   downPmt: '$2,999',
      //   term: '36',
      //   miles: '10',
      //   disclaimer: 'Includes any MFS lease cash available and any lease bonus cash available. Excludes $650 acquisition fee, dealer fee $899, FL electronic filing $199.87, FL tag. Requires a $2,999 down payment. Lease offers are 36 months. 10k miles/year. Not to be combined with any other offer. Expires 3/31/2023.',
      // },
      {
        type: 'Finance',
        lease: 'false',
        pmt: '3.9%',
        downPmt: '',
        term: '60',
        miles: '',
        disclaimer: 'Well qualified buyers when financed through participating lender; not all buyers will qualify. Amount of down payment and other factors may affect qualification. Expires 3/31/2023.',
      },
      {
        type: 'Mazda Loyalty Reward Program',
        lease: 'false',
        pmt: '$500',
        downPmt: '',
        term: '',
        miles: '',
        disclaimer: 'Mazda Loyalty Reward provides $500 for current Mazda customers who purchase or lease a new and unused 2022 or 2023 Mazda vehicle. The reward may be combined with public offers, including lease offers, customer cash back, and APR incentives/offers. Customers may combine Mazda Loyalty Reward with Mazda Military Appreciation Bonus Cash. Additional private incentives must specify combination with Mazda Loyalty Reward. Transferable within household (must live at the same address). Proof of eligibility and residency required. Must present dealer with current registration title, current Mazda sales contract or Mazda Financial Services Agreement and valid driver’s license. Certain restrictions may apply; Must take new retail delivery from dealer stock by 3/31/2023.',
      }
    ],
  },
  {
    key: '1441',
    is_active: false,
    title: '2022 Mazda CX-30 2.5 S Turbo',
    year: '2022',
    make: 'Mazda',
    model: 'CX-30',
    bodyStyle: 'SUV',
    trim: '2.5 Turbo',
    transmission: 'AT',
    drivetrain: 'AWD',
    subTitle: '',
    url: '/searchnew.aspx?year=2022&model=Mazda+CX-30&trim=2.5+Turbo',
    image: 'https://res.cloudinary.com/cfmp/image/upload/v1644526202/vehicles/cgi/mazda/2022/cx-30/cx30-turbo.png',
    lifestyleImage: '',
    features: [],
    special: [
      {
        type: 'Lease',
        lease: 'true',
        pmt: '295',
        downPmt: '15% Of MSRP',
        term: '36',
        miles: '10',
        disclaimer: 'Includes any MFS lease cash available and any lease bonus cash available. Excludes $650 acquisition fee, dealer fee $899, FL electronic filing $199.87, FL tag. Requires a 15% of MSRP down payment. Lease offers are 36 months. 10k miles/year. Not to be combined with any other offer. Expires 3/31/2023.',
      },
      // {
      //   type: 'Lease',
      //   lease: 'true',
      //   pmt: '316',
      //   downPmt: '$2,999',
      //   term: '36',
      //   miles: '10',
      //   disclaimer: 'Includes any MFS lease cash available and any lease bonus cash available. Excludes $650 acquisition fee, dealer fee $899, FL electronic filing $199.87, FL tag. Requires a $2,999 down payment. Lease offers are 36 months. 10k miles/year. Not to be combined with any other offer. Expires 3/31/2023.',
      // },
      {
        type: 'Finance',
        lease: 'false',
        pmt: '3.9%',
        downPmt: '',
        term: '60',
        miles: '',
        disclaimer: 'Well qualified buyers when financed through participating lender; not all buyers will qualify. Amount of down payment and other factors may affect qualification. Expires 3/31/2023.',
      },
      {
        type: 'Mazda Loyalty Reward Program',
        lease: 'false',
        pmt: '$500',
        downPmt: '',
        term: '',
        miles: '',
        disclaimer: 'Mazda Loyalty Reward provides $500 for current Mazda customers who purchase or lease a new and unused 2022 or 2023 Mazda vehicle. The reward may be combined with public offers, including lease offers, customer cash back, and APR incentives/offers. Customers may combine Mazda Loyalty Reward with Mazda Military Appreciation Bonus Cash. Additional private incentives must specify combination with Mazda Loyalty Reward. Transferable within household (must live at the same address). Proof of eligibility and residency required. Must present dealer with current registration title, current Mazda sales contract or Mazda Financial Services Agreement and valid driver’s license. Certain restrictions may apply; Must take new retail delivery from dealer stock by 3/31/2023.',
      }
    ],
  },
  {
    key: '1451',
    is_active: false,
    title: '2022 Mazda CX-30 2.5 Turbo Premium Package',
    year: '2022',
    make: 'Mazda',
    model: 'CX-30',
    bodyStyle: 'SUV',
    trim: '2.5 Turbo Premium Package',
    transmission: 'AT',
    drivetrain: 'AWD',
    subTitle: '',
    url: '/searchnew.aspx?year=2022&model=Mazda+CX-30&trim=2.5+Turbo+Premium+Package',
    image: 'https://res.cloudinary.com/cfmp/image/upload/f_auto/v1644526202/vehicles/cgi/mazda/2022/cx-30/cx30-turbo-premium.png',
    lifestyleImage: '',
    features: [],
    special: [
      {
        type: 'Lease',
        lease: 'true',
        pmt: '320',
        downPmt: '15% Of MSRP',
        term: '36',
        miles: '10',
        disclaimer: 'Includes any MFS lease cash available and any lease bonus cash available. Excludes $650 acquisition fee, dealer fee $899, FL electronic filing $199.87, FL tag. Requires a 15% of MSRP down payment. Lease offers are 36 months. 10k miles/year. Not to be combined with any other offer. Expires 3/31/2023.',
      },
      // {
      //   type: 'Lease',
      //   lease: 'true',
      //   pmt: '336',
      //   downPmt: '$2,999',
      //   term: '36',
      //   miles: '10',
      //   disclaimer: 'Includes any MFS lease cash available and any lease bonus cash available. Excludes $650 acquisition fee, dealer fee $899, FL electronic filing $199.87, FL tag. Requires a $2,999 down payment. Lease offers are 36 months. 10k miles/year. Not to be combined with any other offer. Expires 3/31/2023.',
      // },
      {
        type: 'Finance',
        lease: 'false',
        pmt: '3.9%',
        downPmt: '',
        term: '60',
        miles: '',
        disclaimer: 'Well qualified buyers when financed through participating lender; not all buyers will qualify. Amount of down payment and other factors may affect qualification. Expires 3/31/2023.',
      },
      {
        type: 'Mazda Loyalty Reward Program',
        lease: 'false',
        pmt: '$500',
        downPmt: '',
        term: '',
        miles: '',
        disclaimer: 'Mazda Loyalty Reward provides $500 for current Mazda customers who purchase or lease a new and unused 2022 or 2023 Mazda vehicle. The reward may be combined with public offers, including lease offers, customer cash back, and APR incentives/offers. Customers may combine Mazda Loyalty Reward with Mazda Military Appreciation Bonus Cash. Additional private incentives must specify combination with Mazda Loyalty Reward. Transferable within household (must live at the same address). Proof of eligibility and residency required. Must present dealer with current registration title, current Mazda sales contract or Mazda Financial Services Agreement and valid driver’s license. Certain restrictions may apply; Must take new retail delivery from dealer stock by 3/31/2023.',
      }
    ],
  },
  {
    key: '1461',
    is_active: false,
    title: '2022 Mazda CX-30 2.5 Turbo Premium Plus',
    year: '2022',
    make: 'Mazda',
    model: 'CX-30',
    bodyStyle: 'SUV',
    trim: '2.5 Turbo Premium Plus',
    transmission: 'AT',
    drivetrain: 'AWD',
    subTitle: '',
    url: '/searchnew.aspx?year=2022&model=Mazda+CX-30&trim=2.5+Turbo+Premium+Plus',
    image: 'https://res.cloudinary.com/cfmp/image/upload/f_auto/v1644526202/vehicles/cgi/mazda/2022/cx-30/cx30-turbo-premium-plus.png',
    lifestyleImage: '',
    features: [],
    special: [
      // {
      //   type: 'Lease',
      //   lease: 'true',
      //   pmt: '355',
      //   downPmt: '15% Of MSRP',
      //   term: '36',
      //   miles: '10',
      //   disclaimer: 'Includes any MFS lease cash available and any lease bonus cash available. Excludes $650 acquisition fee, dealer fee $899, FL electronic filing $199.87, FL tag. Requires a 15% of MSRP down payment. Lease offers are 36 months. 10k miles/year. Not to be combined with any other offer. Expires 3/31/2023.',
      // },
      {
        type: 'True Sign & Drive',
        lease: 'true',
        pmt: '479',
        downPmt: '$0 Down',
        term: '36',
        miles: '10',
        disclaimer: '$0 cash down, $0 security deposit, $0 due at signing. Sign &amp; Drive lease offer for 36 months, 10k miles/year. Not to be combined with any other offer. Expires 3/31/2023.',
      },
      // {
      //   type: 'Lease',
      //   lease: 'true',
      //   pmt: '377',
      //   downPmt: '$2,999',
      //   term: '36',
      //   miles: '10',
      //   disclaimer: 'Includes any MFS lease cash available and any lease bonus cash available. Excludes $650 acquisition fee, dealer fee $899, FL electronic filing $199.87, FL tag. Requires a $2,999 down payment. Lease offers are 36 months. 10k miles/year. Not to be combined with any other offer. Expires 3/31/2023.',
      // },
      {
        type: 'Finance',
        lease: 'false',
        pmt: '0%',
        downPmt: '',
        term: '36',
        miles: '',
        disclaimer: 'Well qualified buyers when financed through participating lender; not all buyers will qualify. Amount of down payment and other factors may affect qualification. Expires 3/31/2023.',
      },
      {
        type: 'Mazda Loyalty Reward Program',
        lease: 'false',
        pmt: '$500',
        downPmt: '',
        term: '',
        miles: '',
        disclaimer: 'Mazda Loyalty Reward provides $500 for current Mazda customers who purchase or lease a new and unused 2022 or 2023 Mazda vehicle. The reward may be combined with public offers, including lease offers, customer cash back, and APR incentives/offers. Customers may combine Mazda Loyalty Reward with Mazda Military Appreciation Bonus Cash. Additional private incentives must specify combination with Mazda Loyalty Reward. Transferable within household (must live at the same address). Proof of eligibility and residency required. Must present dealer with current registration title, current Mazda sales contract or Mazda Financial Services Agreement and valid driver’s license. Certain restrictions may apply; Must take new retail delivery from dealer stock by 3/31/2023.',
      }
    ],
  },
  {
    key: '2023502',
    is_active: false,
    title: '2023 Mazda CX-50 2.5S Preferred Package AT AWD',
    year: '2023',
    make: 'Mazda',
    model: 'CX-50',
    bodyStyle: 'SUV',
    trim: '2.5S Preferred Package',
    transmission: 'AT',
    drivetrain: 'AWD',
    subTitle: '',
    url: '/searchnew.aspx?year=2023&model=Mazda+CX-50&trim=2.5S+Preferred',
    image: 'https://res.cloudinary.com/cfmp/image/upload/f_auto/v1659639072/vehicles/cgi/mazda/2023/cx-50/2023-mazda-cx-50-2.5-s-preferred-package-machine-gray.png',
    lifestyleImage: '',
    features: [],
    special: [
      // {
      //   type: 'No Payments For 90 Days',
      //   lease: 'false',
      //   pmt: '',
      //   downPmt: '',
      //   term: '',
      //   miles: '',
      //   disclaimer: 'No payments for 90 days for well qualified buyers. May require financing through participating lender. Certain restrictions may apply; Must take new retail delivery from dealer stock by 3/31/2023. See dealer for complete details.',
      // },
      {
        type: 'Lease',
        lease: 'true',
        pmt: '304',
        downPmt: '15% Of MSRP',
        term: '36',
        miles: '10',
        disclaimer: 'Includes any MFS lease cash available and any lease bonus cash available. Excludes $650 acquisition fee, dealer fee $899, FL electronic filing $199.87, FL tag. Requires a 15% of MSRP down payment. Lease offers are 36 months. 10k miles/year. Not to be combined with any other offer. Expires 3/31/2023.',
      },
      // {
      //   type: 'Lease',
      //   lease: 'true',
      //   pmt: '284',
      //   downPmt: '10% Of MSRP',
      //   term: '36',
      //   miles: '10',
      //   disclaimer: 'Includes any MFS lease cash available and any lease bonus cash available. Excludes $650 acquisition fee, dealer fee $899, FL electronic filing $199.87, FL tag. Requires 10% of MSRP as down payment. Lease offers are 36 months. 10k miles/year. Not to be combined with any other offer. Expires 3/31/2023.',
      // },
      {
        type: 'Finance',
        lease: 'false',
        pmt: '2.9%',
        downPmt: '',
        term: '36',
        miles: '',
        disclaimer: 'Well qualified buyers when financed through participating lender; not all buyers will qualify. Amount of down payment and other factors may affect qualification. Expires 3/31/2023.',
      },
      {
        type: 'Mazda Loyalty Reward Program',
        lease: 'false',
        pmt: '$500',
        downPmt: '',
        term: '',
        miles: '',
        disclaimer: 'Mazda Loyalty Reward provides $500 for current Mazda customers who purchase or lease a new and unused 2022 or 2023 Mazda vehicle. The reward may be combined with public offers, including lease offers, customer cash back, and APR incentives/offers. Customers may combine Mazda Loyalty Reward with Mazda Military Appreciation Bonus Cash. Additional private incentives must specify combination with Mazda Loyalty Reward. Transferable within household (must live at the same address). Proof of eligibility and residency required. Must present dealer with current registration title, current Mazda sales contract or Mazda Financial Services Agreement and valid driver’s license. Certain restrictions may apply; Must take new retail delivery from dealer stock by 3/31/2023.',
      }
    ],
  },
  {
    key: '2023503',
    is_active: true,
    title: '2023 Mazda CX-50 2.5 S Preferred Plus AT AWD',
    year: '2023',
    make: 'Mazda',
    model: 'CX-50',
    bodyStyle: 'SUV',
    trim: '2.5 Preferred Plus',
    transmission: 'AT',
    drivetrain: 'AWD',
    subTitle: '',
    url: '/searchnew.aspx?year=2023&model=Mazda+CX-50&trim=2.5+Preferred+Plus+AWD',
    image: 'https://res.cloudinary.com/cfmp/image/upload/f_auto/v1659639072/vehicles/cgi/mazda/2023/cx-50/2023-mazda-cx-50-2.5-s-preferred-plus-package-soul-red.png',
    lifestyleImage: '',
    features: [],
    special: [
      // {
      //   type: 'No Payments For 90 Days',
      //   lease: 'false',
      //   pmt: '',
      //   downPmt: '',
      //   term: '',
      //   miles: '',
      //   disclaimer: 'No payments for 90 days for well qualified buyers. May require financing through participating lender. Certain restrictions may apply; Must take new retail delivery from dealer stock by 3/31/2023. See dealer for complete details.',
      // },
      {
        type: 'Lease',
        lease: 'true',
        pmt: '352',
        downPmt: '15% Of MSRP',
        term: '36',
        miles: '10',
        disclaimer: 'Includes any MFS lease cash available and any lease bonus cash available. Excludes $650 acquisition fee, dealer fee $899, FL electronic filing $199.87, FL tag. Requires a 15% of MSRP down payment. Lease offers are 36 months. 10k miles/year. Not to be combined with any other offer. Expires 3/31/2023.',
      },
      // {
      //   type: 'Lease',
      //   lease: 'true',
      //   pmt: '284',
      //   downPmt: '10% Of MSRP',
      //   term: '36',
      //   miles: '10',
      //   disclaimer: 'Includes any MFS lease cash available and any lease bonus cash available. Excludes $650 acquisition fee, dealer fee $899, FL electronic filing $199.87, FL tag. Requires 10% of MSRP as down payment. Lease offers are 36 months. 10k miles/year. Not to be combined with any other offer. Expires 3/31/2023.',
      // },
      {
        type: 'Finance',
        lease: 'false',
        pmt: '0%',
        downPmt: '',
        term: '36',
        miles: '',
        disclaimer: 'Well qualified buyers when financed through participating lender; not all buyers will qualify. Amount of down payment and other factors may affect qualification. Expires 3/31/2023.',
      },
      {
        type: 'Mazda Loyalty Reward Program',
        lease: 'false',
        pmt: '$500',
        downPmt: '',
        term: '',
        miles: '',
        disclaimer: 'Mazda Loyalty Reward provides $500 for current Mazda customers who purchase or lease a new and unused 2022 or 2023 Mazda vehicle. The reward may be combined with public offers, including lease offers, customer cash back, and APR incentives/offers. Customers may combine Mazda Loyalty Reward with Mazda Military Appreciation Bonus Cash. Additional private incentives must specify combination with Mazda Loyalty Reward. Transferable within household (must live at the same address). Proof of eligibility and residency required. Must present dealer with current registration title, current Mazda sales contract or Mazda Financial Services Agreement and valid driver’s license. Certain restrictions may apply; Must take new retail delivery from dealer stock by 3/31/2023.',
      }
    ],
  },
  {
    key: '2001',
    is_active: true,
    title: '2023 Mazda CX-50 2.5 Turbo Premium Plus Package AT AWD',
    year: '2023',
    make: 'Mazda',
    model: 'CX-50',
    bodyStyle: 'SUV',
    trim: '2.5 Turbo Premium Plus Package',
    transmission: 'AT',
    drivetrain: 'AWD',
    subTitle: '',
    url: '/searchnew.aspx?year=2023&model=Mazda+CX-50&trim=2.5+Turbo+Premium+Plus+AWD',
    image: 'https://res.cloudinary.com/cfmp/image/upload/f_auto/v1659639072/vehicles/cgi/mazda/2023/cx-50/2023-mazda-cx-50-2.5-turbo-premium-plus-package-polymetal-gray.png',
    lifestyleImage: '',
    features: [],
    special: [
      // {
      //   type: 'No Payments For 90 Days',
      //   lease: 'false',
      //   pmt: '',
      //   downPmt: '',
      //   term: '',
      //   miles: '',
      //   disclaimer: 'No payments for 90 days for well qualified buyers. May require financing through participating lender. Certain restrictions may apply; Must take new retail delivery from dealer stock by 3/31/2023. See dealer for complete details.',
      // },
      {
        type: 'Lease',
        lease: 'true',
        pmt: '458',
        downPmt: '15% Of MSRP',
        term: '36',
        miles: '10',
        disclaimer: 'Includes any MFS lease cash available and any lease bonus cash available. Excludes $650 acquisition fee, dealer fee $899, FL electronic filing $199.87, FL tag. Requires a 15% of MSRP down payment. Lease offers are 36 months. 10k miles/year. Not to be combined with any other offer. Expires 3/31/2023.',
      },
      // {
      //   type: 'Lease',
      //   lease: 'true',
      //   pmt: '284',
      //   downPmt: '10% Of MSRP',
      //   term: '36',
      //   miles: '10',
      //   disclaimer: 'Includes any MFS lease cash available and any lease bonus cash available. Excludes $650 acquisition fee, dealer fee $899, FL electronic filing $199.87, FL tag. Requires 10% of MSRP as down payment. Lease offers are 36 months. 10k miles/year. Not to be combined with any other offer. Expires 3/31/2023.',
      // },
      {
        type: 'Finance',
        lease: 'false',
        pmt: '0%',
        downPmt: '',
        term: '36',
        miles: '',
        disclaimer: 'Well qualified buyers when financed through participating lender; not all buyers will qualify. Amount of down payment and other factors may affect qualification. Expires 3/31/2023.',
      },
      {
        type: 'Mazda Loyalty Reward Program',
        lease: 'false',
        pmt: '$500',
        downPmt: '',
        term: '',
        miles: '',
        disclaimer: 'Mazda Loyalty Reward provides $500 for current Mazda customers who purchase or lease a new and unused 2022 or 2023 Mazda vehicle. The reward may be combined with public offers, including lease offers, customer cash back, and APR incentives/offers. Customers may combine Mazda Loyalty Reward with Mazda Military Appreciation Bonus Cash. Additional private incentives must specify combination with Mazda Loyalty Reward. Transferable within household (must live at the same address). Proof of eligibility and residency required. Must present dealer with current registration title, current Mazda sales contract or Mazda Financial Services Agreement and valid driver’s license. Certain restrictions may apply; Must take new retail delivery from dealer stock by 3/31/2023.',
      }
    ],
  },

  ]
}
